const PRODUCT_DEFAULT_CONFIG = {
  "ref-youandsea10th-tote": {
    baseColor: "NATURAL",
    colorImage: {
      defaultImage:"Windand",
      defaultColor: "ORANGE",
    },
    textField: {
      defaultText: "",
      defaultColor: "",
      maxLength: 6, 
      alartLength: 1,  
      inputType: "alphabetic", // アルファベットのみ
      errorMessage: "",
      label: "",
      propertiesSuffix: "Free_",
      validationEnabled: false 
    },
    cartButtonAlert: {
      enabled: true,
      message: "文字を入力していない場合、「刺繍なし」でお届けします。"
    },
    bodyEmbroideryColors: {
      "NATURAL": "ORANGE",
      "BLACK": "WHITE",
      "NAVY": "BLUE",
      "BLUE": "WHITE",
      "RED": "BLACK",
      "YELLOW": "NAVY"
    },
    componentToggle: {
      enabled: false, //画像orテキストどちらかを表示
      textFieldThreshold: 1,
      radioToggleEnabled: true, //ref-youandsea10th-toteのみture
      defaultMode: "text"
    }
  }
};


// loadSpinner();
// const redirectTimeout = window.setTimeout(function () {
//     location.href = "/pages/too-much-traffic";
// }, 10000);
mounted();

var productSlug;
var bodyVariant;
var customMode = "text";

async function mounted() {
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      selectFirstOptions();
    }
  });
  

  // ベースカラーとプロダクトスラッグを取得
  var tags = document.querySelector(".you-and-sea-options").getAttribute("data-tags").replace(/\s+/g, "").split(",");
  for (var i = 0; i < tags.length; i++) {
    var regProductSlug = tags[i].match(new RegExp("custom-product-slug=([A-Za-z0-9-]+)"));
    if (regProductSlug && regProductSlug.length > 1) {
      productSlug = regProductSlug[1];
    }
  }
  
  const fieldset = document.querySelector("fieldset[data-product-tags*='custom-product-slug=']");
  const selectedValueEl = fieldset?.querySelector("legend span[data-selected-value]");
  if (selectedValueEl) {
    bodyVariant = selectedValueEl.textContent.trim().toUpperCase();
  } else {
    console.warn("bodyVariant not found from legend");
  }
  console.log("bodyVariant is " + bodyVariant);
  console.log("productSlug is " + productSlug);

  if (productSlug === "ref-youandsea10th-tote" && 
      PRODUCT_DEFAULT_CONFIG[productSlug]?.bodyEmbroideryColors && 
      bodyVariant) {
    // bodyVariant に対応する刺繍カラーを取得
    const embroideryColor = PRODUCT_DEFAULT_CONFIG[productSlug].bodyEmbroideryColors[bodyVariant];
    
    // デフォルト刺繍カラーとして設定
    if (embroideryColor) {
      if (!PRODUCT_DEFAULT_CONFIG[productSlug].textField) {
        PRODUCT_DEFAULT_CONFIG[productSlug].textField = {};
      }
      PRODUCT_DEFAULT_CONFIG[productSlug].textField.defaultColor = embroideryColor;
    }
  }

  // カスタムオプションを取得
  const customOptions = await fetchCustomOptions();
  if (!customOptions) {
    console.log("customOptions is null");
    // 外部APIデータ取得失敗時
    const fallbackImage = document.querySelector(".product_youandsea .product__image_default");
    if (fallbackImage) {
      fallbackImage.style.display = "block";
    }
    return;
  }
  // カスタムオプションを設定
  createFieldsForm(customOptions.fields);
  createImageLayers(customOptions);

  createCustomModeToggle();
  // zoom 機能を有効にする
  if (!navigator.userAgent.match(/iPhone|Android.+Mobile/) && !productSlug.includes("rug")) {
    var all = document.querySelectorAll(".product-options-image-customizer img");
    var imageEl = document.querySelector(".product-options-image-customizer");
    if (!imageEl) {
      return;
    }
    imageEl.style.height = "auto";

    imageEl.addEventListener("mousemove", function (e) {
      imageEl.style.cursor = "zoom-in";
      imageEl.classList.add("zoom-mode");
      var b, t, i, o, n, a;
      b = document.querySelector(".product-options-image-customizer img.option-customizer-layer");
      n = b.naturalWidth;
      i = b.naturalHeight;
      a = imageEl.clientWidth / n;
      o = imageEl.clientHeight / i;
      var rect = imageEl.getBoundingClientRect();
      var parentRect = imageEl.offsetParent.getBoundingClientRect();
      n = ((e.pageX - rect.left - parentRect.left) / imageEl.clientWidth) * n * (1 - a);
      a = ((e.pageY - window.scrollY - rect.top - parentRect.top) / imageEl.clientHeight) * i * (1 - o);
      var textfieldEl = document.querySelector(".product-options-textfield");
      var splitNumber = [];
      if (textfieldEl) {
        splitNumber = textfieldEl.value.split("");
      }
      for (i = 0; i < all.length; i++) {
        if (all[i].src != "") {
          all[i].style.width = "1200px";
          all[i].style.height = "675px";
          all[i].style.maxWidth = "initial";
          // tee5th number用 →elseのみで表示する
          if (productSlug == "23ss-youandsea-tee1" && all[i].classList.contains("number-customizer-image")) {
            if (splitNumber.length == 2) {
              if (all[i].classList.contains("op-01")) {
                all[i].style.left = "-" + (n + numberPotionOffset2Zoom * 2) + "px";
              } else if (all[i].classList.contains("op-02")) {
                all[i].style.left = "-" + (n - numberPotionOffset2Zoom * 2) + "px";
              } else {
                all[i].style.left = "-" + n + "px";
              }
            } else if (splitNumber.length == 3) {
              if (all[i].classList.contains("op-01")) {
                all[i].style.left = "-" + (n + numberPotionOffset3Zoom * 2) + "px";
              } else if (all[i].classList.contains("op-03")) {
                all[i].style.left = "-" + (n - numberPotionOffset3Zoom * 2) + "px";
              } else {
                all[i].style.left = "-" + n + "px";
              }
            } else if (splitNumber.length == 4) {
              if (all[i].classList.contains("op-01")) {
                all[i].style.left = "-" + (n + numberPotionOffset4_4Zoom * 2) + "px";
              } else if (all[i].classList.contains("op-02")) {
                all[i].style.left = "-" + (n + numberPotionOffset4_2Zoom * 2) + "px";
              } else if (all[i].classList.contains("op-03")) {
                all[i].style.left = "-" + (n - numberPotionOffset4_2Zoom * 2) + "px";
              } else if (all[i].classList.contains("op-04")) {
                all[i].style.left = "-" + (n - numberPotionOffset4_4Zoom * 2) + "px";
              }
            } else {
              all[i].style.left = "-" + n + "px";
            }
            all[i].style.top = "-" + a + "px";
          } else {
            all[i].style.left = "-" + n + "px";
            all[i].style.top = "-" + a + "px";
          }
        }
      }
    });

    imageEl.addEventListener("mouseout", function (e) {
      imageEl.classList.remove("zoom-mode");
      imageEl.style.cursor = "default";
      var textfieldEl = document.querySelector(".product-options-textfield");
      var splitNumber = [];
      if (textfieldEl) {
        splitNumber = textfieldEl.value.split("");
      }
      for (var i = 0; i < all.length; i++) {
        if (all[i].src != "") {
          all[i].style.width = "100%";
          all[i].style.height = "auto";
          all[i].style.maxWidth = "100%";
          all[i].style.top = "0";
          if (productSlug == "23ss-youandsea-tee1" && all[i].classList.contains("number-customizer-image")) {
            if (splitNumber.length == 2) {
              if (all[i].classList.contains("op-01")) {
                all[i].style.left = "-" + numberPotionOffset2 + "%";
              } else if (all[i].classList.contains("op-02")) {
                all[i].style.left = numberPotionOffset2 + "%";
              } else {
                all[i].style.left = "0";
              }
            } else if (splitNumber.length == 3) {
              if (all[i].classList.contains("op-01")) {
                all[i].style.left = "-" + numberPotionOffset3 + "%";
              } else if (all[i].classList.contains("op-03")) {
                all[i].style.left = numberPotionOffset3 + "%";
              } else {
                all[i].style.left = "0";
              }
            } else if (splitNumber.length == 4) {
              if (all[i].classList.contains("op-01")) {
                all[i].style.left = "-" + numberPotionOffset4_4 + "%";
              } else if (all[i].classList.contains("op-02")) {
                all[i].style.left = "-" + numberPotionOffset4_2 + "%";
              } else if (all[i].classList.contains("op-03")) {
                all[i].style.left = numberPotionOffset4_2 + "%";
              } else if (all[i].classList.contains("op-04")) {
                all[i].style.left = numberPotionOffset4_4 + "%";
              }
            } else {
              all[i].style.left = "0";
            }
          } else {
            all[i].style.left = "0";
          }
        }
      }
    });
  }

  document.removeEventListener('change', handleColorChange);
  document.addEventListener('change', handleColorChange);

  selectFirstColorRadio();
  selectFirstOptions();

  if (PRODUCT_DEFAULT_CONFIG[productSlug]?.componentToggle?.enabled) {
    const textField = document.querySelector('.product-options-textfield');
    if (textField) {
      toggleComponentsByTextLength(textField);
    }
  }

  const moreOptionsBtn = document.getElementById("more-payment-options-link");
  if (moreOptionsBtn && PRODUCT_DEFAULT_CONFIG[productSlug]?.cartButtonAlert?.enabled) {
    moreOptionsBtn.addEventListener("click", function (e) {
      const config = PRODUCT_DEFAULT_CONFIG[productSlug];
      const textField = document.querySelector(".product-options-textfield");

      if (textField) {
        const value = textField.value.trim();
        const minLength = config.textField.alartLength || 1;

        if (value.length < minLength) {
          const message = config.cartButtonAlert.message || "入力が足りません。";
          const confirmed = window.confirm(message);

          if (!confirmed) {
            e.preventDefault();
            e.stopImmediatePropagation(); 
            return false; 
          }
        }
      }
    }, true);
  }

}

function handleColorChange(e) {
  if (e.target.type !== 'radio') return;

  const fieldset = e.target.closest('fieldset[data-product-tags]');
  if (!fieldset || !fieldset.dataset.productTags.includes('custom-product-slug=')) return;

  const selected = fieldset.querySelector('input[type="radio"]:checked');
  if (!selected) return;
  
  const newVariant = selected.value.trim().toUpperCase();
  if (bodyVariant === newVariant) return;
  
  if (window.colorChangeTimeout) {
    clearTimeout(window.colorChangeTimeout);
  }
  
  window.colorChangeTimeout = setTimeout(() => {
    processColorChange(newVariant);
  }, 50);
}

let customBaseColors = [];

async function fetchCustomOptions() {
  var baseImageUrl = "";
  var fields;
  try {
    var apiUrl = "";
    if (
      location.hostname == "windandsea.jp" ||
      location.hostname == "www.windandsea.jp" ||
      location.hostname == "windandsea-wear.myshopify.com"
    ) {
      apiUrl = "https://youandsea.windandsea.jp/products/options/";
    } else {
      apiUrl = "https://staging-youandsea.windandsea.jp/products/options/";
    }

    const res = await fetch(apiUrl + productSlug);
    if (!res.ok) {
      if (res.status === 429) {
        // 混雑時のみリダイレクト
        location.href = "/pages/too-much-traffic";
      }
      throw new Error(`API error: ${res.status}`);
    }

    const data = await res.json();
    customBaseColors = data.bases;

    if (data) {
      data.bases.forEach(function (base) {
        if (base.bodyColor == bodyVariant) {
          baseImageUrl = base.imageUrl;
        }
      });
    }
    fields = data.fields;

    return {
      baseImageUrl: baseImageUrl,
      fields: fields,
    };
  } catch (error) {
    console.error("API取得失敗", error);
  }
}
// async function fetchCustomOptions() {
//   var baseImageUrl = "";
//   var fields;
//   try {
//     // hostでcdn先を分岐
//     var apiUrl = "";
//     if (location.hostname == "windandsea.jp" || location.hostname == "www.windandsea.jp" || location.hostname == "windandsea-wear.myshopify.com" || location.hostname == "windandsea-wear.myshopify.com") {
//       apiUrl = "https://youandsea.windandsea.jp/products/options/";
//     } else {
//       apiUrl = "https://staging-youandsea.windandsea.jp/products/options/";
//     }
//     const res = await fetch(apiUrl + productSlug);
//     const data = await res.json();
//     console.log("[LOAD] loaded custom options", data);

//     if (data) {
//       data.bases.forEach(function (base) {
//         if (base.bodyColor == bodyVariant) {
//           baseImageUrl = base.imageUrl;
//         }
//       });
//     }
//     fields = data.fields;

//     return {
//       baseImageUrl: baseImageUrl,
//       fields: fields,
//     };
//   } catch (error) {
//     console.log(error);
//     location.href = "/pages/too-much-traffic";
//   }
// }

function createFieldsForm(fields) {
  var parentEl = document.querySelector(".you-and-sea-options");
  var groupNames = [];
  fields.forEach(function (field) {
    if (!groupNames.includes(field.groupName)) {
      groupNames.push(field.groupName);
    }
  });
  groupNames.forEach(function (groupName, i) {
    var groupEl = document.createElement("div");
    
    // if (productSlug !== "24ss-youandsea-st2") {
    //   groupEl.setAttribute("onclick", "onClickAccordionOpen(this)");
    // }
    groupEl.setAttribute("data-group-name", groupName);
    parentEl.appendChild(groupEl);

    if (groupName !== "") {
      
      var groupTitleEl = document.createElement("div");
        groupTitleEl.classList.add("po-accordion-title");
        groupTitleEl.innerHTML = groupName;
      groupEl.appendChild(groupTitleEl);
    }

    fields.forEach(function (field) {
      // formTypeの種類の判別
      let kind = checkFormType(field.formType);

      switch (kind) {
        case "ColorPicker":
          if (field.groupName == groupName) {
            var optionsContainerEl = document.createElement("div");
            optionsContainerEl.classList.add("product-options-control-container");
            optionsContainerEl.setAttribute("data-name", field.positionName);
            optionsContainerEl.setAttribute("data-tip", "");
            optionsContainerEl.setAttribute("data-group-name", field.groupName);
            optionsContainerEl.setAttribute("data-mode", "bottom");
            optionsContainerEl.addEventListener("click", function (e) {
              e.stopPropagation();
            });
            groupEl.appendChild(optionsContainerEl);

            var fieldNameEl = document.createElement("div");
            fieldNameEl.classList.add("product-options-field-name");
            fieldNameEl.innerHTML = field.positionName;
            optionsContainerEl.appendChild(fieldNameEl);

            var fieldTypeEl = document.createElement("div");
            fieldTypeEl.classList.add("product-options-colorpicker-container");
            optionsContainerEl.appendChild(fieldTypeEl);

            field.formColorValues.forEach(function (formColorValue) {
              var fieldEl = document.createElement("div");
              fieldEl.classList.add("product-options-colorpicker");
              fieldEl.classList.add("options-tip");
              fieldEl.setAttribute("data-tip", formColorValue.name);
              fieldEl.setAttribute("data-name", formColorValue.name);
              fieldEl.setAttribute("data-value", `${formColorValue.name}{${formColorValue.code}}`);
              fieldEl.setAttribute("data-option-position-name", field.positionName);
              fieldEl.setAttribute("data-option-group-name", field.groupName);
              fieldEl.setAttribute("onclick", "onClickColorPicker(this)");
              optionsContainerEl.appendChild(fieldEl);

              var fieldBackgroundEl = document.createElement("div");
              fieldBackgroundEl.classList.add("product-options-color-span");
              fieldBackgroundEl.style.background = formColorValue.code;
              fieldEl.appendChild(fieldBackgroundEl);
            });

            var fieldInputEl = document.createElement("input");
            fieldInputEl.setAttribute("type", "hidden");
            fieldInputEl.setAttribute("name", `properties[${field.positionName}]`);
            fieldInputEl.setAttribute("value", "None");
            optionsContainerEl.appendChild(fieldInputEl);
          }
          break;
        case "ImagePicker":
          if (field.groupName == groupName) {
            var optionsContainerEl = document.createElement("div");
            optionsContainerEl.classList.add("product-options-control-container");
            optionsContainerEl.setAttribute("data-name", field.positionName);
            optionsContainerEl.setAttribute("data-tip", "");
            optionsContainerEl.setAttribute("data-group-name", field.groupName);
            optionsContainerEl.setAttribute("data-mode", "bottom");
            optionsContainerEl.addEventListener("click", function (e) {
              e.stopPropagation();
            });
            groupEl.appendChild(optionsContainerEl);

            var fieldNameEl1 = document.createElement("div");
            fieldNameEl1.classList.add("product-options-field-name");
           
            fieldNameEl1.innerHTML = `${field.positionName}`;
            optionsContainerEl.appendChild(fieldNameEl1);

            var fieldBoxEl1 = document.createElement("div");
            fieldBoxEl1.classList.add("product-options-picker-container");
            optionsContainerEl.appendChild(fieldBoxEl1);

            field.formImageValues.forEach(function (formImageValue) {
              
              var fieldEl = document.createElement("div");
              fieldEl.classList.add("product-options-imagepicker");
              fieldEl.classList.add("options-tip");
              fieldEl.setAttribute("data-tip", formImageValue.name);
              fieldEl.setAttribute("data-name", formImageValue.name);
              fieldEl.setAttribute("data-value", `${formImageValue.name}`);
              fieldEl.setAttribute("data-option-position-name", field.positionName);
              fieldEl.setAttribute("data-option-group-name", field.groupName);
              fieldEl.addEventListener("click", function (e) {
                onClickImagePicker(this, productSlug);
              });
              fieldBoxEl1.appendChild(fieldEl);

              let fieldImageEl = document.createElement("img");
              fieldImageEl.src = formImageValue.thumbnailUrl;
              fieldImageEl.alt = formImageValue.thumbnailName;
              fieldImageEl.classList.add("product-options-image-span");
              fieldEl.appendChild(fieldImageEl);
            });

            var fieldInputEl = document.createElement("input");
            fieldInputEl.setAttribute("type", "hidden");
            fieldInputEl.setAttribute("name", `properties[${field.positionName}]`);
            fieldInputEl.setAttribute("value", "None");
            optionsContainerEl.appendChild(fieldInputEl);
            
          }
          break;
        case "ImagePickerAndImagePicker2":
          if (field.groupName == groupName) {
            var optionsContainerEl = document.createElement("div");
            optionsContainerEl.classList.add("product-options-control-container");
            optionsContainerEl.setAttribute("data-name", field.positionName);
            optionsContainerEl.setAttribute("data-tip", "");
            optionsContainerEl.setAttribute("data-group-name", field.groupName);
            optionsContainerEl.setAttribute("data-mode", "bottom");
            optionsContainerEl.addEventListener("click", function (e) {
              e.stopPropagation();
            });
            groupEl.appendChild(optionsContainerEl);

            var fieldNameEl1 = document.createElement("div");
            fieldNameEl1.classList.add("product-options-field-name");
            fieldNameEl1.innerHTML = `${field.positionName}`;
            optionsContainerEl.appendChild(fieldNameEl1);

            var fieldNameEl1_2 = document.createElement("div");
            fieldNameEl1_2.classList.add("product-options-field-name");
            fieldNameEl1_2.classList.add("caption");
            fieldNameEl1_2.innerHTML = `Custom 1`;
            optionsContainerEl.appendChild(fieldNameEl1_2);

            var fieldBoxEl1 = document.createElement("div");
            fieldBoxEl1.classList.add("product-options-picker-container");
            optionsContainerEl.appendChild(fieldBoxEl1);

            field.formImageValues.forEach(function (formImageValue) {
              var fieldEl = document.createElement("div");
              fieldEl.classList.add("product-options-imagepicker");
              fieldEl.classList.add("options-tip");
              fieldEl.setAttribute("data-tip", formImageValue.name);
              fieldEl.setAttribute("data-name", formImageValue.name);
              fieldEl.setAttribute("data-value", `${formImageValue.name}`);
              fieldEl.setAttribute("data-option-position-name", field.positionName);
              fieldEl.setAttribute("data-option-group-name", field.groupName);
              if (productSlug === "24ss-youandsea-st2") {
                fieldEl.addEventListener("click", function (e) {
                  onClickImageAndImagePickerSf2(this, productSlug);
                });
              } else {
                fieldEl.addEventListener("click", function (e) {
                  onClickImageAndImagePicker(this, productSlug);
                });
              }
              fieldBoxEl1.appendChild(fieldEl);

              let fieldImageEl = document.createElement("img");
              fieldImageEl.src = formImageValue.thumbnailUrl;
              fieldImageEl.alt = formImageValue.thumbnailName;
              fieldImageEl.classList.add("product-options-image-span");
              fieldEl.appendChild(fieldImageEl);
            });

            var fieldInputEl = document.createElement("input");
            fieldInputEl.setAttribute("type", "hidden");
            fieldInputEl.setAttribute("name", `properties[${field.positionName}]`);
            fieldInputEl.setAttribute("value", "None");
            optionsContainerEl.appendChild(fieldInputEl);
          }
          break;
        case "ColorPickerAndImagePicker":
          if (field.groupName == groupName) {
            var optionsContainerEl = document.createElement("div");
            optionsContainerEl.classList.add("product-options-control-container");
            optionsContainerEl.setAttribute("data-name", field.positionName);
            optionsContainerEl.setAttribute("data-tip", "");
            optionsContainerEl.setAttribute("data-group-name", field.groupName);
            optionsContainerEl.setAttribute("data-mode", "bottom");
            optionsContainerEl.addEventListener("click", function (e) {
              e.stopPropagation();
            });
            groupEl.appendChild(optionsContainerEl);

            var fieldNameEl1 = document.createElement("div");
            fieldNameEl1.classList.add("product-options-field-name");
            // fieldNameEl1.innerHTML = `Logo-${field.positionName}`;
            fieldNameEl1.innerHTML = `${field.positionName}`;
            optionsContainerEl.appendChild(fieldNameEl1);

            var fieldBoxEl1 = document.createElement("div");
            fieldBoxEl1.classList.add("product-options-picker-container");
            optionsContainerEl.appendChild(fieldBoxEl1);

            field.formImageValues.forEach(function (formImageValue) {
              var fieldEl = document.createElement("div");
              fieldEl.classList.add("product-options-imagepicker");
              fieldEl.classList.add("options-tip");
              fieldEl.setAttribute("data-tip", formImageValue.name);
              fieldEl.setAttribute("data-name", formImageValue.name);
              fieldEl.setAttribute("data-value", `${formImageValue.name}`);
              fieldEl.setAttribute("data-option-position-name", field.positionName);
              fieldEl.setAttribute("data-option-group-name", field.groupName);
              fieldEl.addEventListener("click", function (e) {
                onClickColorAndImagePicker(this, productSlug);
              });

              if (PRODUCT_DEFAULT_CONFIG[productSlug] && 
                  PRODUCT_DEFAULT_CONFIG[productSlug].colorImage && 
                  PRODUCT_DEFAULT_CONFIG[productSlug].colorImage.defaultImage === formImageValue.name) {
                fieldEl.classList.add("imagepicker-selected");
              }

              fieldBoxEl1.appendChild(fieldEl);

              let fieldImageEl = document.createElement("img");
              fieldImageEl.src = formImageValue.thumbnailUrl;
              fieldImageEl.alt = formImageValue.thumbnailName;
              fieldImageEl.classList.add("product-options-image-span");
              fieldEl.appendChild(fieldImageEl);
            });

            var fieldNameEl2 = document.createElement("div");
            fieldNameEl2.classList.add("product-options-field-name");
            // fieldNameEl2.innerHTML = "Color";
            optionsContainerEl.appendChild(fieldNameEl2);

            var fieldBoxEl2 = document.createElement("div");
            fieldBoxEl2.classList.add("product-options-picker-container");
            optionsContainerEl.appendChild(fieldBoxEl2);

            field.formColorValues.forEach(function (formColorValue) {
              var fieldEl = document.createElement("div");
              fieldEl.classList.add("product-options-colorpicker");
              fieldEl.classList.add("options-tip");
              fieldEl.setAttribute("data-tip", formColorValue.name);
              fieldEl.setAttribute("data-name", formColorValue.name);
              fieldEl.setAttribute("data-value", `${formColorValue.name}{${formColorValue.code}}`);
              fieldEl.setAttribute("data-option-position-name", field.positionName);
              fieldEl.setAttribute("data-option-group-name", field.groupName);
              fieldEl.setAttribute("onclick", "onClickColorAndImagePicker2(this)");
             
              if (!(PRODUCT_DEFAULT_CONFIG[productSlug]?.bodyEmbroideryColors)) {
                fieldEl.setAttribute("onclick", "onClickColorAndImagePicker2(this)");
              } else {
                fieldEl.style.pointerEvents = "none";
              }

              if (PRODUCT_DEFAULT_CONFIG[productSlug] && 
                  PRODUCT_DEFAULT_CONFIG[productSlug].colorImage && 
                  PRODUCT_DEFAULT_CONFIG[productSlug].colorImage.defaultColor === formColorValue.name) {
                fieldEl.classList.add("colorpicker-selected");
              }
              fieldBoxEl2.appendChild(fieldEl);

              var fieldBackgroundEl = document.createElement("div");
              fieldBackgroundEl.classList.add("product-options-color-span");
              fieldBackgroundEl.style.background = formColorValue.code;
              fieldEl.appendChild(fieldBackgroundEl);
            });

            var fieldInputEl = document.createElement("input");
            fieldInputEl.setAttribute("type", "hidden");
            fieldInputEl.setAttribute("name", `properties[${field.positionName}]`);
            fieldInputEl.setAttribute("value", "None");
            optionsContainerEl.appendChild(fieldInputEl);
          }
          break;
        case "TextField":
          if (field.groupName == groupName) {
            var optionsContainerEl = document.createElement("div");
            optionsContainerEl.classList.add("product-options-control-container");
            optionsContainerEl.setAttribute("data-name", field.positionName);
            optionsContainerEl.setAttribute("data-tip", "");
            optionsContainerEl.setAttribute("data-group-name", field.groupName);
            optionsContainerEl.setAttribute("data-mode", "bottom");
            optionsContainerEl.addEventListener("click", function (e) {
              e.stopPropagation();
            });
            groupEl.appendChild(optionsContainerEl);

            var fieldNameEl = document.createElement("div");
            fieldNameEl.classList.add("product-options-field-name");
            fieldNameEl.innerHTML = field.positionName;
            optionsContainerEl.appendChild(fieldNameEl);

            // formを作成
            var fieldEl = document.createElement("input");
            fieldEl.classList.add("product-options-textfield");
            fieldEl.setAttribute("type", "text");
            fieldEl.setAttribute("maxlength", 4);
            fieldEl.setAttribute("placeholder", "ex.1987");
            fieldEl.setAttribute("autocomplete", "off");
            fieldEl.setAttribute("data-name", "textField");
            fieldEl.addEventListener("input", function (e) {
              onChangeNumber(this, productSlug);
            });
            // スマホで決定ボタンをおした時にformがsubmitされるのを防ぎ、キーボードを閉じる挙動にする
            fieldEl.addEventListener("keypress", function (e) {
              if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();
                this.blur();
              }
            });
            optionsContainerEl.appendChild(fieldEl);

            // 送信するためのinputを作成
            var fieldInputEl = document.createElement("input");
            fieldInputEl.setAttribute("type", "hidden");
            fieldInputEl.setAttribute("name", `properties[${field.positionName}]`);
            fieldInputEl.classList.add("product-options-textfield-value");
            optionsContainerEl.appendChild(fieldInputEl);
          }
          break;
        case "ColorPickerAndTextField":
          if (field.groupName == groupName) {
            var optionsContainerEl = document.createElement("div");
            optionsContainerEl.classList.add("product-options-control-container");
            optionsContainerEl.setAttribute("data-name", field.positionName);
            optionsContainerEl.setAttribute("data-tip", "");
            optionsContainerEl.setAttribute("data-group-name", field.groupName);
            optionsContainerEl.setAttribute("data-mode", "bottom");
            optionsContainerEl.addEventListener("click", function (e) {
              e.stopPropagation();
            });
            groupEl.appendChild(optionsContainerEl);

            var fieldNameEl = document.createElement("div");
            fieldNameEl.classList.add("product-options-field-name");

            let labelText = "";
            if (PRODUCT_DEFAULT_CONFIG[productSlug] && 
                PRODUCT_DEFAULT_CONFIG[productSlug].textField && 
                PRODUCT_DEFAULT_CONFIG[productSlug].textField.label) {
              labelText = PRODUCT_DEFAULT_CONFIG[productSlug].textField.label;
            }
            
            fieldNameEl.innerHTML = `${field.positionName} ${labelText}`;
            optionsContainerEl.appendChild(fieldNameEl);

            // formを作成
            var fieldEl = document.createElement("input");
            fieldEl.classList.add("product-options-textfield");
            fieldEl.setAttribute("type", "text");
            
            let maxLength = 4;
            let placeholder = "ex.1987";
            let errorMessage = "※4文字未満の場合は、数字の刺繍なしでお届けします。"; // デフォルトメッセージ
            let defaultText = "";

            if (PRODUCT_DEFAULT_CONFIG[productSlug] && PRODUCT_DEFAULT_CONFIG[productSlug].textField) {
              const config = PRODUCT_DEFAULT_CONFIG[productSlug].textField;
              
              if (config.maxLength) {
                maxLength = config.maxLength;
              }
              
              if (config.errorMessage) {
                errorMessage = config.errorMessage;
              }
              if (config.defaultText) {
                defaultText = config.defaultText;
              }
              
              if (config.inputType === "alphabetic") {
                placeholder = "ex.ABCD";
              } else if (config.inputType === "alphanumeric") {
                placeholder = "ex.A1B2";
              }
            }
            
            fieldEl.setAttribute("maxlength", maxLength);
            fieldEl.setAttribute("placeholder", placeholder);
            fieldEl.setAttribute("autocomplete", "off");
            fieldEl.setAttribute("data-name", "textField");

            // fieldEl.addEventListener("input", function (e) {
            //   onChangeColorPickerAndTextField(this, productSlug);
            // });
            fieldEl.addEventListener("compositionstart", function(e) {
              this.isComposing = true;
            });
            
            fieldEl.addEventListener("compositionend", function(e) {
              this.isComposing = false;
              // 変換確定時に改めてバリデーションと整形を実行
              onChangeColorPickerAndTextField(this, productSlug);
            });
            
            // 既存のinputイベントを修正
            fieldEl.addEventListener("input", function(e) {
              if (!this.isComposing) {
                onChangeColorPickerAndTextField(this, productSlug);
              }
            });
            
            // ここで blur（フォーカスアウト）時に、もし値が空ならストレージを更新する
            fieldEl.addEventListener("blur", function () {
              if (this.value.trim() === "") {
                // ユーザーが完全に空にしたとき、ストレージも空に更新
                saveToSessionStorage(productSlug, {
                  textField: {
                    selectedText: "",
                    selectedColor: ""
                  }
                });
              }
            });
            
            // スマホで決定ボタンをおした時の挙動（Enterキー対策）
            fieldEl.addEventListener("keypress", function (e) {
              if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();
                this.blur();
              }
            });
            optionsContainerEl.appendChild(fieldEl);


            if (defaultText) {
              fieldEl.value = defaultText;
            }


            fieldEl.addEventListener("input", function (e) {
              onChangeColorPickerAndTextField(this, productSlug);
            });

            fieldEl.addEventListener("keypress", function (e) {
              if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();
                this.blur();
              }
            });
            optionsContainerEl.appendChild(fieldEl);
            var alertEl = document.createElement("div");
            alertEl.classList.add("product-options-textfield-alert");
            alertEl.innerHTML = errorMessage;
            optionsContainerEl.appendChild(alertEl);

            var fieldBoxEl1 = document.createElement("div");
            fieldBoxEl1.classList.add("product-options-picker-container");
            optionsContainerEl.appendChild(fieldBoxEl1);

            field.formColorValues.forEach(function (formColorValue) {
              var fieldEl = document.createElement("div");
              fieldEl.classList.add("product-options-colorpicker");
              fieldEl.classList.add("options-tip");
              fieldEl.setAttribute("data-tip", formColorValue.name);
              fieldEl.setAttribute("data-name", formColorValue.name);
              fieldEl.setAttribute("data-value", `${formColorValue.name}{${formColorValue.code}}`);
              fieldEl.setAttribute("data-option-position-name", field.positionName);
              fieldEl.setAttribute("data-option-group-name", field.groupName);
              fieldEl.setAttribute("onclick", "onClickColorPickerAndTextField(this)");

              if (!(PRODUCT_DEFAULT_CONFIG[productSlug]?.bodyEmbroideryColors)) {
                fieldEl.setAttribute("onclick", "onClickColorPickerAndTextField(this)");
              } else {
                fieldEl.style.pointerEvents = "none";
              }

              if (PRODUCT_DEFAULT_CONFIG[productSlug] && 
                  PRODUCT_DEFAULT_CONFIG[productSlug].textField && 
                  PRODUCT_DEFAULT_CONFIG[productSlug].textField.defaultColor && 
                  formColorValue.name.toUpperCase() === PRODUCT_DEFAULT_CONFIG[productSlug].textField.defaultColor.toUpperCase()) {
                fieldEl.classList.add("colorpicker-selected");
              }

              fieldBoxEl1.appendChild(fieldEl);

              var fieldBackgroundEl = document.createElement("div");
              fieldBackgroundEl.classList.add("product-options-color-span");
              fieldBackgroundEl.style.background = formColorValue.code;
              fieldEl.appendChild(fieldBackgroundEl);
            });

            // 送信するためのinputを作成
            var fieldInputEl = document.createElement("input");
            fieldInputEl.setAttribute("type", "hidden");
            fieldInputEl.setAttribute("name", `properties[${field.positionName}]`);
            fieldInputEl.classList.add("product-options-colorpicker-textfield-value");
            optionsContainerEl.appendChild(fieldInputEl);
          }
          break;
        default:
          // それ以外の場合
          break;
      }
    });
  });
}
function createCustomModeToggle() {
  if (!PRODUCT_DEFAULT_CONFIG[productSlug]?.componentToggle?.radioToggleEnabled) {
    return;
  }
  
  const parentEl = document.querySelector(".you-and-sea-options");
  if (!parentEl) return;
  
  const existingToggle = parentEl.querySelector(".custom-mode-toggle");
  if (existingToggle) {
    existingToggle.remove();
  }
  
  const sessionData = JSON.parse(sessionStorage.getItem("YANDS_SELECTED") || "{}")[productSlug] || {};
  customMode = sessionData.customMode || PRODUCT_DEFAULT_CONFIG[productSlug].componentToggle.defaultMode || "text";
  
  const availableModes = [];
  
  const logoContainers = document.querySelectorAll('.product-options-control-container:has(.product-options-imagepicker):not(:has(.product-options-textfield))');
  if (logoContainers.length > 0) {
    availableModes.push({
      id: 'logo',
      label: 'LOGO'
    });
  }
  
  const textFieldContainer = document.querySelector('.product-options-control-container:has(.product-options-textfield)');
  if (textFieldContainer) {
    availableModes.push({
      id: 'text',
      label: 'ORIGINAL TEXT'
    });
  }
  
  if (availableModes.length === 0) return;
  
  if (!availableModes.some(mode => mode.id === customMode)) {
    customMode = availableModes[0].id;
  }
  
  const toggleContainer = document.createElement("div");
  toggleContainer.classList.add("custom-mode-toggle");
  
  const fieldName = document.createElement("div");
  fieldName.classList.add("product-options-field-name");
  fieldName.textContent = "SELECT";
  toggleContainer.appendChild(fieldName); 
  
  const radioWrapper = document.createElement("div");
  radioWrapper.classList.add("custom-radio-wrapper");
  toggleContainer.appendChild(radioWrapper); 
  
  availableModes.forEach(mode => {
    const label = document.createElement("label");
    label.classList.add("custom-radio");
    
    const imgContainer = document.createElement("div");
    imgContainer.classList.add("custom-select-icon");
    
    const img = document.createElement("img");
    img.classList.add("custom-radio-image");
    
    if (mode.id === 'logo') {
      const imagePickers = document.querySelectorAll('.product-options-imagepicker.options-tip');
      if (imagePickers.length > 0) {
        const firstImagePicker = imagePickers[0];
        const thumbnailImg = firstImagePicker.querySelector('img');
        if (thumbnailImg && thumbnailImg.src) {
          img.src = thumbnailImg.src;
        } else {
          img.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='black' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='3' width='18' height='18' rx='2' ry='2'%3E%3C/rect%3E%3Ccircle cx='8.5' cy='8.5' r='1.5'%3E%3C/circle%3E%3Cpolyline points='21 15 16 10 5 21'%3E%3C/polyline%3E%3C/svg%3E";
        }
      } else {
        img.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='black' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='3' width='18' height='18' rx='2' ry='2'%3E%3C/rect%3E%3Ccircle cx='8.5' cy='8.5' r='1.5'%3E%3C/circle%3E%3Cpolyline points='21 15 16 10 5 21'%3E%3C/polyline%3E%3C/svg%3E";
      }
    } else {
      img.src = window.themeAssetUrls?.yandsText;
    }
    
    imgContainer.appendChild(img);
    label.appendChild(imgContainer);
    
    const radio = document.createElement("input");
    radio.type = "radio";
    radio.name = "customMode";
    radio.value = mode.id;
    radio.checked = customMode === mode.id;
    label.appendChild(radio);
    
    const span = document.createElement("span");
    span.textContent = mode.label;
    label.appendChild(span);
    
    radioWrapper.appendChild(label);
  });
  
  radioWrapper.addEventListener("change", function(e) {
    if (e.target.type === "radio") {
      customMode = e.target.value;
      
      saveToSessionStorage(productSlug, {
        customMode: customMode
      });
      
      applyCustomMode();
    }
  });
  
  const accordionTitle = document.querySelector(".po-accordion-title");
  if (accordionTitle) {
    const parentElement = accordionTitle.parentElement;
    parentElement.insertBefore(toggleContainer, accordionTitle.nextSibling);
  } else {
    const parentEl = document.querySelector(".you-and-sea-options");
    if (parentEl) {
      parentEl.insertBefore(toggleContainer, parentEl.firstChild);
    }
  }
  
  applyCustomMode();
}

function applyCustomMode() {
  const textFieldContainer = document.querySelector('.product-options-control-container:has(.product-options-textfield)');
  const logoContainers = document.querySelectorAll('.product-options-control-container:has(.product-options-imagepicker):not(:has(.product-options-textfield))');
  
  if (PRODUCT_DEFAULT_CONFIG[productSlug]?.componentToggle?.radioToggleEnabled) {
 
    logoContainers.forEach(c => {
      c.style.display = 'none';
    });
    
    if (textFieldContainer) {
      const colorPickerContainer = textFieldContainer.querySelector('.product-options-picker-container');
      if (colorPickerContainer) {
        colorPickerContainer.classList.add('color-picker-single-mode');
        
        if (!colorPickerContainer.querySelector('.color-label')) {
          const colorLabel = document.createElement('div');
          colorLabel.className = 'product-options-field-name color-label';
          colorLabel.textContent = 'LOGO COLOR';
          colorPickerContainer.insertBefore(colorLabel, colorPickerContainer.firstChild);
        }
      }
      
      const fieldName = textFieldContainer.querySelector('.product-options-field-name:not(.color-label)');
      if (fieldName) {
        if (!fieldName.getAttribute('data-original-text')) {
          fieldName.setAttribute('data-original-text', fieldName.textContent.trim());
        }
        
        fieldName.textContent = "TEXT";
      }
    }
    
    logoContainers.forEach(container => {
      const colorPickerContainer = container.querySelector('.product-options-picker-container');
      if (colorPickerContainer) {
        colorPickerContainer.classList.add('color-picker-single-mode');
        
        if (!colorPickerContainer.querySelector('.color-label')) {
          const colorLabel = document.createElement('div');
          colorLabel.className = 'product-options-field-name color-label';
          colorLabel.textContent = 'COLOR';
          colorPickerContainer.insertBefore(colorLabel, colorPickerContainer.firstChild);
        }
      }
    });
  } else {
    if (textFieldContainer) {
      const colorPickerContainer = textFieldContainer.querySelector('.product-options-picker-container');
      if (colorPickerContainer) {
        colorPickerContainer.classList.remove('color-picker-single-mode');
        
        const colorLabel = colorPickerContainer.querySelector('.color-label');
        if (colorLabel) {
          colorPickerContainer.removeChild(colorLabel);
        }
      }
      
      const fieldName = textFieldContainer.querySelector('.product-options-field-name:not(.color-label)');
      if (fieldName && fieldName.getAttribute('data-original-text')) {
        fieldName.textContent = fieldName.getAttribute('data-original-text');
      }
    }
    
    logoContainers.forEach(container => {
      const colorPickerContainer = container.querySelector('.product-options-picker-container');
      if (colorPickerContainer) {
        colorPickerContainer.classList.remove('color-picker-single-mode');
        
        const colorLabel = colorPickerContainer.querySelector('.color-label');
        if (colorLabel) {
          colorPickerContainer.removeChild(colorLabel);
        }
      }
    });
  }
  
  if (customMode === "text") {
    if (textFieldContainer) {
      textFieldContainer.style.pointerEvents = "auto";
      
      const disableElements = textFieldContainer.querySelectorAll('.product-options-field-name:not(.color-label), .product-options-textfield, .product-options-textfield-alert');
      disableElements.forEach(el => {
        el.classList.remove('text-field-disabled');
      });
    }
    
    document.querySelectorAll('[data-customizer-image-color-name]').forEach(layer => {
      layer.classList.add('customizer-layer-hidden');
      layer.classList.remove('customizer-layer-showing');
    });
    
    const textField = textFieldContainer?.querySelector('.product-options-textfield');
    if (textField) {
      textField.dispatchEvent(new Event('input', { bubbles: true }));
    }
  } else {
    if (textFieldContainer) {
      textFieldContainer.style.pointerEvents = "none";
      
      const disableElements = textFieldContainer.querySelectorAll('.product-options-field-name:not(.color-label), .product-options-textfield, .product-options-textfield-alert');
      disableElements.forEach(el => {
        el.classList.add('text-field-disabled');
      });
      
      const textField = textFieldContainer.querySelector('.product-options-textfield');
      if (textField) {
        textField.value = '';
        
        saveToSessionStorage(productSlug, {
          textField: {
            selectedText: "",
            selectedColor: ""
          }
        });
        
        const fieldInputEl = textFieldContainer.querySelector('.product-options-colorpicker-textfield-value');
        if (fieldInputEl) {
          fieldInputEl.value = "None";
        }
        
        textField.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
    
    document.querySelectorAll('.number-customizer-layer').forEach(layer => {
      layer.classList.add('customizer-layer-hidden');
      layer.classList.remove('customizer-layer-showing');
    });
    
    const selectedImage = document.querySelector('.product-options-imagepicker.imagepicker-selected');
    const selectedColor = document.querySelector('.product-options-colorpicker.colorpicker-selected');
    
    if (selectedImage && selectedColor) {
      const positionName = selectedImage.getAttribute('data-option-position-name');
      const imageName = selectedImage.getAttribute('data-name');
      const colorName = selectedColor.getAttribute('data-name');
      const toDataName = `${imageName}_${colorName}`;
      
      document.querySelectorAll(`[data-customizer-position-name="${positionName}"]`).forEach(layer => {
        if (layer.getAttribute('data-customizer-image-color-name') === toDataName) {
          layer.classList.remove('customizer-layer-hidden');
          layer.classList.add('customizer-layer-showing');
        }
      });
    }
  }
  updateFormBasedOnMode();
}

function updateFormBasedOnMode() {
  const form = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;
  
  const propertyInputs = form.querySelectorAll('input[name^="properties["]');
  propertyInputs.forEach(input => input.remove());
  
  if (customMode === "text") {
    const textFieldContainer = document.querySelector('.product-options-control-container:has(.product-options-textfield)');
    if (textFieldContainer) {
      const textField = textFieldContainer.querySelector('.product-options-textfield');
      const selectedColor = textFieldContainer.querySelector('.product-options-colorpicker.colorpicker-selected');
      
      if (textField && textField.value && selectedColor) {
        const positionName = textFieldContainer.getAttribute('data-name');
        const colorName = selectedColor.getAttribute('data-name');
        const alertLength = PRODUCT_DEFAULT_CONFIG[productSlug]?.textField?.alartLength || 1;
        
        if (textField.value.length >= alertLength) {
          const hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = `properties[${positionName}]`;
          
          const prefix = PRODUCT_DEFAULT_CONFIG[productSlug]?.textField?.propertiesSuffix || '';
          hiddenInput.value = `${prefix}${textField.value}_${colorName}`;
          
          form.appendChild(hiddenInput);
        }
      }
    }
  } else {
    const logoContainers = document.querySelectorAll('.product-options-control-container:has(.product-options-imagepicker):not(:has(.product-options-textfield))');
    
    logoContainers.forEach(container => {
      const selectedImage = container.querySelector('.product-options-imagepicker.imagepicker-selected');
      const selectedColor = container.querySelector('.product-options-colorpicker.colorpicker-selected');
      
      if (selectedImage && selectedColor) {
        const positionName = container.getAttribute('data-name');
        const imageName = selectedImage.getAttribute('data-name');
        const colorName = selectedColor.getAttribute('data-name');
        
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = `properties[${positionName}]`;
        hiddenInput.value = `${imageName}_${colorName}`;
        
        form.appendChild(hiddenInput);
      }
    });
  }
}

function checkFormType(formType) {
  // TODO SlectBoxの場合の処理を追加
  if (formType.length > 1 && formType.includes("ColorPicker") && formType.includes("ImagePicker")) {
    return "ColorPickerAndImagePicker";
  } else if (formType.length > 1 && formType.includes("ImagePicker") && formType.includes("ImagePicker2")) {
    return "ImagePickerAndImagePicker2";
  } else if (formType.length > 1 && formType.includes("ColorPicker") && formType.includes("TextField")) {
    return "ColorPickerAndTextField";
  } else if (formType.length == 1) {
    if (formType.includes("ColorPicker")) {
      return "ColorPicker";
    } else if (formType.includes("ImagePicker")) {
      return "ImagePicker";
    } else if (formType.includes("TextField")) {
      return "TextField";
    }
  }
}

function createImageLayers(customOptions) {
  console.log("customOptions", customOptions);
  console.log("bodyVariant", bodyVariant);
  var parentEl = document.querySelector(".product-options-image-customizer");
  window.addEventListener("resize", () => {
    resizeWindow(productSlug);
  });
  resizeWindow(productSlug);
  var baseEl = document.createElement("img");
  baseEl.classList.add("option-customizer-layer");
  baseEl.classList.add("option-customizer-base-layer");
  if (customOptions.baseImageUrl) {
    baseEl.setAttribute("src", customOptions.baseImageUrl);
  }
  parentEl.appendChild(baseEl);

  customOptions.fields.forEach(function (field) {
    let kind = checkFormType(field.formType);
    switch (kind) {
      case "ColorPickerAndImagePicker":
        field.formImageValues.forEach(function (value) {
          value.secondColorValues.forEach(function (secondValue) {
            var optionEl = document.createElement("img");
            optionEl.classList.add("option-customizer-layer");
            optionEl.classList.add("customizer-layer-hidden");
            optionEl.setAttribute("data-customizer-position-name", field.positionName);
            optionEl.setAttribute("data-customizer-group-name", field.groupName);
            optionEl.setAttribute("data-customizer-image-color-name", value.name + "_" + secondValue.name);
            if (secondValue.imageUrl) {
              optionEl.setAttribute("src", secondValue.imageUrl);
            }
            parentEl.appendChild(optionEl);
          });
        });
        break;
      case "ColorPicker":
        field.formColorValues.forEach(function (value) {
          var optionEl = document.createElement("img");
          optionEl.classList.add("option-customizer-layer");
          optionEl.classList.add("customizer-layer-hidden");
          optionEl.setAttribute("data-customizer-position-name", field.positionName);
          optionEl.setAttribute("data-customizer-group-name", field.groupName);
          optionEl.setAttribute("data-customizer-color-name", value.name);
          if (field.groupName == "BACK" && field.positionName == "Top") {
            optionEl.classList.add("customizer-front-layer");
          }
          if (value.imageUrl) {
            optionEl.setAttribute("src", value.imageUrl);
          }
          if (bodyVariant == "SMALL") {
            optionEl.style.transform = "scale(0.7)";
          }
          parentEl.appendChild(optionEl);
        });
        break;
      case "ImagePicker":
        field.formImageValues.forEach(function (value) {
          var optionEl = document.createElement("img");
          optionEl.classList.add("option-customizer-layer");
          optionEl.classList.add("customizer-layer-hidden");
          optionEl.setAttribute("data-customizer-position-name", field.positionName);
          optionEl.setAttribute("data-customizer-group-name", field.groupName);
          optionEl.setAttribute("data-customizer-color-name", value.name);
          if (value.imageUrl) {
            optionEl.setAttribute("src", value.imageUrl);
          }
          parentEl.appendChild(optionEl);
        });
        break;
      case "ImagePickerAndImagePicker2":
        field.formImageValues.forEach(function (value) {
          var optionEl = document.createElement("img");
          optionEl.classList.add("option-customizer-layer");
          optionEl.classList.add("customizer-layer-hidden");
          optionEl.setAttribute("data-customizer-position-name", field.positionName);
          optionEl.setAttribute("data-customizer-group-name", field.groupName);
          optionEl.setAttribute("data-customizer-color-name", value.name);
          if (value.imageUrl) {
            optionEl.setAttribute("src", value.imageUrl);
          }
          parentEl.appendChild(optionEl);
        });
        
        field.formImageValues.forEach(function (value) {
          value.secondImageValues.forEach(function (secondValue) {
            var optionEl = document.createElement("img");
            optionEl.classList.add("option-customizer-layer");
            optionEl.classList.add("customizer-layer-hidden");
            optionEl.setAttribute("data-customizer-position-name", field.positionName);
            optionEl.setAttribute("data-customizer-group-name", field.groupName);
            optionEl.setAttribute("data-customizer-image-color-name", value.name + "_" + secondValue.name);
            if (secondValue.imageUrl) {
              optionEl.setAttribute("src", secondValue.imageUrl);
            }
            parentEl.appendChild(optionEl);
          });
        });
        break;
      case "TextField":
        var optionEl = document.createElement("div");
        optionEl.classList.add("option-customizer-layer");
        optionEl.classList.add("customizer-layer-hidden");
        optionEl.classList.add("number-customizer-layer");
        optionEl.setAttribute("data-customizer-position-name", field.positionName);
        optionEl.setAttribute("data-customizer-group-name", field.groupName);
        optionEl.style.opacity = 1;

        parentEl.appendChild(optionEl);

        var optionImageEl = document.createElement("img");
        optionImageEl.setAttribute("src", customOptions.baseImageUrl);
        optionImageEl.classList.add("op-01");
        optionImageEl.classList.add("number-customizer-image");
        optionImageEl.style.opacity = 0;
        optionEl.appendChild(optionImageEl);

        var optionImageEl2 = document.createElement("img");
        optionImageEl2.setAttribute("src", customOptions.baseImageUrl);
        optionImageEl2.classList.add("op-02");
        optionImageEl2.classList.add("number-customizer-image");
        optionImageEl2.style.opacity = 0;
        optionEl.appendChild(optionImageEl2);

        var optionImageEl3 = document.createElement("img");
        optionImageEl3.setAttribute("src", customOptions.baseImageUrl);
        optionImageEl3.classList.add("op-03");
        optionImageEl3.classList.add("number-customizer-image");
        optionImageEl3.style.opacity = 0;
        optionEl.appendChild(optionImageEl3);

        var optionImageEl4 = document.createElement("img");
        optionImageEl4.setAttribute("src", customOptions.baseImageUrl);
        optionImageEl4.classList.add("op-04");
        optionImageEl4.classList.add("number-customizer-image");
        optionImageEl4.style.opacity = 0;
        optionEl.appendChild(optionImageEl4);
        break;
      case "ColorPickerAndTextField":
        var optionEl = document.createElement("div");
        optionEl.classList.add("option-customizer-layer");
        optionEl.classList.add("customizer-layer-hidden");
        optionEl.classList.add("number-customizer-layer");
        optionEl.setAttribute("data-customizer-position-name", field.positionName);
        optionEl.setAttribute("data-customizer-group-name", field.groupName);

        parentEl.appendChild(optionEl);

        const slugConfig = PRODUCT_DEFAULT_CONFIG[productSlug];
        const maxLength = slugConfig?.textField?.maxLength || 4;

        for (let i = 0; i < maxLength; i++) {
          const numberImg = document.createElement("img");
          // numberImg.setAttribute("src", customOptions.baseImageUrl);
          numberImg.classList.add(`op-0${i + 1}`, "number-customizer-image");
          numberImg.style.opacity = 0;
          optionEl.appendChild(numberImg);
        }
        break;
    }
  });
}

function resizeWindow(productSlug) {
  const parentEl = document.querySelector(".product-options-image-customizer");

  if (window.innerWidth < 769) {
    if (productSlug.includes("rug")) {
      const thumbnailHeight = window.innerWidth * 0.7;
      parentEl.style.height = `${thumbnailHeight}px`;
      parentEl.style.aspectRatio = '';
    } else {
      parentEl.style.height = ''; 
      parentEl.style.aspectRatio = '16 / 9';
    }
  } else {
    parentEl.style.height = '';
    parentEl.style.aspectRatio = '';
  }
}


function updateFormHiddenInputFromElement(el) {
  const value = el.getAttribute("data-name");
  const position = el.getAttribute("data-option-position-name");

  if (!position || !value) {
    console.warn("Missing data-name or data-option-position-name", el);
    return;
  }

  const form = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;

  // すでにあれば削除して更新
  const existingInput = form.querySelector(`input[name="properties[${position}]"]`);
  if (existingInput) {
    existingInput.remove();
  }

  const hiddenInput = document.createElement("input");
  hiddenInput.type = "hidden";
  hiddenInput.name = `properties[${position}]`;
  hiddenInput.value = value;
  form.appendChild(hiddenInput);
}

function updateFormHiddenInputFromInput(inputEl) {
  if (inputEl && inputEl.name && inputEl.value) {
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    const existingInput = form.querySelector(`input[name="${inputEl.name}"]`);
    if (existingInput) {
      existingInput.remove();
    }

    const hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = inputEl.name;
    hiddenInput.value = inputEl.value;
    form.appendChild(hiddenInput);
  }
}


function onClickColorPicker(el) {
  var fieldInputEl = el.parentElement.querySelector("input");
  var selectedOptionName = el.getAttribute("data-option-position-name");
  var selectedValue = el.getAttribute("data-name");

  if (!selectedOptionName) {
    console.error("Error: `data-option-position-name` が見つかりません。", el);
    return;
  }

  fieldInputEl.setAttribute("value", selectedValue);

  el.parentElement.querySelectorAll(".product-options-colorpicker").forEach(function (option) {
    if (option == el) {
      option.classList.add("colorpicker-selected");
    } else {
      option.classList.remove("colorpicker-selected");
    }
  });

  updateFormHiddenInputFromInput(fieldInputEl);

  var elems = document.querySelectorAll(`[data-customizer-position-name="${selectedOptionName}"]`);
  elems.forEach(function (elem) {
    if (elem.getAttribute("data-customizer-color-name") == selectedValue) {
      elem.classList.remove("customizer-layer-hidden");
      elem.classList.add("customizer-layer-showing");
    } else {
      elem.classList.add("customizer-layer-hidden");
      elem.classList.remove("customizer-layer-showing");
    }
  });
  saveColorPickerSelection();
}


function onClickImagePicker(el) {
  var fieldInputEl = el.parentElement.parentElement.querySelector("input");
  fieldInputEl.setAttribute("value", el.getAttribute("data-name"));
  el.parentElement.querySelectorAll(".product-options-imagepicker").forEach(function (option) {
    if (option == el) {
      option.classList.add("imagepicker-selected");
    } else {
      option.classList.remove("imagepicker-selected");
    }
  });

  var selectedPositionName = el.getAttribute("data-option-position-name");
  // 必要であればグループ名でフィルタリングする
  // var selectedGroupName = el.getAttribute("data-option-group-name")
  // var elems = document.querySelectorAll(`[data-customizer-group-name="${selectedGroupName}"]`);
  var elems = document.querySelectorAll(`[data-customizer-position-name="${selectedPositionName}"]`);
  elems.forEach(function (elem) {
    if (elem.getAttribute("data-customizer-color-name") == el.getAttribute("data-name")) {
      elem.classList.remove("customizer-layer-hidden");
      elem.classList.add("customizer-layer-showing");
    } else {
      elem.classList.add("customizer-layer-hidden");
      elem.classList.remove("customizer-layer-showing");
    }
  });

  updateFormHiddenInputFromInput(fieldInputEl);
  saveImagePickerSelection();
}


// カラー×イメージのイメージ選択時
function onClickColorAndImagePicker(el, productSlug) {
  
  const textFieldEl = document.querySelector(".product-options-textfield");
  const config = PRODUCT_DEFAULT_CONFIG[productSlug]?.componentToggle;
  
  if (config?.enabled && 
      textFieldEl && 
      textFieldEl.value.length >= (config.textFieldThreshold || 5)) {
    return;
  }

  var fieldInputEl = el.parentElement.parentElement.querySelector("input");
  el.parentElement.querySelectorAll(".product-options-imagepicker").forEach(function (option) {
    if (option == el) {
      option.classList.add("imagepicker-selected");
    } else {
      option.classList.remove("imagepicker-selected");
    }
  });
  var selectedPositionName = el.getAttribute("data-option-position-name");
  var elems = document.querySelectorAll(`[data-customizer-position-name="${selectedPositionName}"]`);
  var isSelectedColorPickerEl = el.parentElement.parentElement.querySelector(".product-options-colorpicker.colorpicker-selected");
  var toDataName = "";
  // console.log("isSelectedColorPickerEl", isSelectedColorPickerEl);
  if (isSelectedColorPickerEl) {
    toDataName = `${el.getAttribute("data-name")}_${isSelectedColorPickerEl.getAttribute("data-name")}`;
  }
  // console.log("toDataName[onClickColorAndImagePicker]", toDataName);
  if (toDataName.includes("None")) {
    fieldInputEl.setAttribute("value", "None");
  } else {
    fieldInputEl.setAttribute("value", toDataName);
  }
  elems.forEach(function (elem) {
    if (elem.getAttribute("data-customizer-image-color-name") == toDataName) {
      elem.classList.remove("customizer-layer-hidden");
      elem.classList.add("customizer-layer-showing");
    } else {
      elem.classList.add("customizer-layer-hidden");
      elem.classList.remove("customizer-layer-showing");
    }
  });

  // Numberスタイルの変更
  var textfieldEl = document.querySelector(".product-options-textfield");
  if (textfieldEl) {
    onChangeNumber(textfieldEl, productSlug);
  }

  updateFormHiddenInputFromInput(fieldInputEl);
  saveColorImageSelection();
}

// カラー×イメージのカラーの選択時
function onClickColorAndImagePicker2(el) {
  // テキストフィールドの状態を確認
  const textFieldEl = document.querySelector(".product-options-textfield");
  const config = PRODUCT_DEFAULT_CONFIG[productSlug]?.componentToggle;
  
  // コンポーネントトグルが有効で、テキストの長さが閾値以上の場合は処理を中断
  if (config?.enabled && 
      textFieldEl && 
      textFieldEl.value.length >= (config.textFieldThreshold || 5)) {
    return;
  }

  // 以下、元の関数の処理を続ける
  var fieldInputEl = el.parentElement.parentElement.querySelector("input");
  el.parentElement.querySelectorAll(".product-options-colorpicker").forEach(function (option) {
    if (option == el) {
      option.classList.add("colorpicker-selected");
    } else {
      option.classList.remove("colorpicker-selected");
    }
  });
  var selectedPositionName = el.getAttribute("data-option-position-name");
  var elems = document.querySelectorAll(`[data-customizer-position-name="${selectedPositionName}"]`);
  var isSelectedImagePickerEl = el.parentElement.parentElement.querySelector(".product-options-imagepicker.imagepicker-selected");
  var toDataName = "";
  if (isSelectedImagePickerEl) {
    toDataName = `${isSelectedImagePickerEl.getAttribute("data-name")}_${el.getAttribute("data-name")}`;
  }
  // console.log("toDataName[onClickColorAndImagePicker2]", toDataName);
  if (toDataName.includes("None")) {
    fieldInputEl.setAttribute("value", "None");
  } else {
    fieldInputEl.setAttribute("value", toDataName);
  }
  elems.forEach(function (elem) {
    if (elem.getAttribute("data-customizer-image-color-name") == toDataName) {
      elem.classList.remove("customizer-layer-hidden");
      elem.classList.add("customizer-layer-showing");
    } else {
      elem.classList.add("customizer-layer-hidden");
      elem.classList.remove("customizer-layer-showing");
    }
  });
  updateFormHiddenInputFromInput(fieldInputEl);
  saveColorImageSelection();
}

function onClickImageAndImagePicker(el) {
  console.log("onClickImageAndImagePicker", el);
  var fieldInputEl = el.parentElement.parentElement.querySelector("input");
  el.parentElement.querySelectorAll(".product-options-imagepicker").forEach(function (option) {
    if (option == el) {
      option.classList.add("imagepicker-selected");
    } else {
      option.classList.remove("imagepicker-selected");
    }
  });
  
  var selectedPositionName = el.getAttribute("data-option-position-name");
  var elems = document.querySelectorAll(`[data-customizer-position-name="${selectedPositionName}"]`);
  var isSelectedImagePickerEls = el.parentElement.parentElement.querySelectorAll(".product-options-imagepicker.imagepicker-selected");
  console.log("isSelectedImagePickerEls", isSelectedImagePickerEls);
  var toDataName = "";
  if (isSelectedImagePickerEls[1]) {
    toDataName = `${el.getAttribute("data-name")}_${isSelectedImagePickerEls[1].getAttribute("data-name")}`;
  } else {
    toDataName = `${el.getAttribute("data-name")}_None`;
  }
  console.log("toDataName", toDataName);
  fieldInputEl.setAttribute("value", toDataName);

  elems.forEach(function (elem) {
    if (elem.getAttribute("data-customizer-image-color-name") == toDataName) {
      elem.classList.remove("customizer-layer-hidden");
      elem.classList.add("customizer-layer-showing");
    } else {
      elem.classList.add("customizer-layer-hidden");
      elem.classList.remove("customizer-layer-showing");
    }
  });
  updateFormHiddenInputFromInput(fieldInputEl);
}

function onClickImageAndImagePicker2(el) {
  console.log("onClickImageAndImagePicker2", el);
  var isSelectedImagePickerEl = el.parentElement.parentElement.querySelector(".product-options-imagepicker.imagepicker-selected");
  if (isSelectedImagePickerEl) {
    if (isSelectedImagePickerEl.getAttribute("data-name") == "None") {
      if (el.getAttribute("data-name") != "None") {
        alert("この組み合わせは選択できません。Custom1を変更してください。");
        return;
      }
    }
  }
  var fieldInputEl = el.parentElement.parentElement.querySelector("input");
  el.parentElement.querySelectorAll(".product-options-imagepicker").forEach(function (option) {
    if (option == el) {
      option.classList.add("imagepicker-selected");
    } else {
      option.classList.remove("imagepicker-selected");
    }
  });
  var selectedPositionName = el.getAttribute("data-option-position-name");
  var elems = document.querySelectorAll(`[data-customizer-position-name="${selectedPositionName}"]`);
  var toDataName = "";
  if (isSelectedImagePickerEl) {
    toDataName = `${isSelectedImagePickerEl.getAttribute("data-name")}_${el.getAttribute("data-name")}`;
  }
  console.log("toDataName", toDataName);
  fieldInputEl.setAttribute("value", toDataName);

  elems.forEach(function (elem) {
    if (elem.getAttribute("data-customizer-image-color-name") == toDataName) {
      elem.classList.remove("customizer-layer-hidden");
      elem.classList.add("customizer-layer-showing");
    } else {
      elem.classList.add("customizer-layer-hidden");
      elem.classList.remove("customizer-layer-showing");
    }
  });
  updateFormHiddenInputFromInput(fieldInputEl);
}

let slectingCharactor = "1p";

function onClickImageAndImagePickerSf2(el) {
  console.log("onClickImageAndImagePickerSf2", el);
  console.log("slectingCharactor", slectingCharactor);
  var fieldInputEl = el.parentElement.parentElement.querySelector("input");
  el.parentElement.querySelectorAll(".product-options-imagepicker").forEach(function (option) {
    if (option == el) {
      if (slectingCharactor == "1p") {
        option.classList.add("imagepicker-selected1p");
        option.classList.add("selected1p");
        option.classList.remove("selected2p");
      } else {
        option.classList.add("imagepicker-selected2p");
        option.classList.add("selected2p");
        option.classList.remove("selected1p");
      }
    } else {
      if (slectingCharactor == "1p") {
        option.classList.remove("imagepicker-selected1p");
        option.classList.remove("selected1p");
        option.classList.remove("selected2p");
      } else {
        option.classList.remove("imagepicker-selected2p");
        option.classList.remove("selected2p");
        option.classList.remove("selected1p");
      }
    }
  });
  if (slectingCharactor == "1p") {
    var isSelectedImagePicker2pEl = el.parentElement.parentElement.querySelector(".product-options-imagepicker.imagepicker-selected2p");
    console.log("isSelectedImagePicker2pEl", isSelectedImagePicker2pEl);
    var toDataName = "";
    if (isSelectedImagePicker2pEl) {
      toDataName = `${el.getAttribute("data-name")}_${isSelectedImagePicker2pEl.getAttribute("data-name")}`;
    } else {
      toDataName = `${el.getAttribute("data-name")}_None`;
    }
    fieldInputEl.setAttribute("value", toDataName);
  } else {
    var isSelectedImagePicker1pEl = el.parentElement.parentElement.querySelector(".product-options-imagepicker.imagepicker-selected1p");
    console.log("isSelectedImagePicker1pEl", isSelectedImagePicker1pEl);
    var toDataName = "";
    if (isSelectedImagePicker1pEl) {
      toDataName = `${isSelectedImagePicker1pEl.getAttribute("data-name")}_${el.getAttribute("data-name")}`;
    } else {
      toDataName = `None_${el.getAttribute("data-name")}`;
    }
    fieldInputEl.setAttribute("value", toDataName);
  }

  var selectedPositionName = el.getAttribute("data-option-position-name");
  var elems = document.querySelectorAll(`[data-customizer-position-name="${selectedPositionName}"]`);
  elems.forEach(function (elem) {
    if (elem.getAttribute("data-customizer-image-color-name") == toDataName) {
      elem.classList.remove("customizer-layer-hidden");
      elem.classList.add("customizer-layer-showing");
    } else {
      elem.classList.add("customizer-layer-hidden");
      elem.classList.remove("customizer-layer-showing");
    }
  });
  if (slectingCharactor == "1p") {
    slectingCharactor = "2p";
  } else {
    slectingCharactor = "1p";
  }

  updateFormHiddenInputFromInput(fieldInputEl);
}

function onClickAccordionOpen(el) {
  el.classList.toggle("open");
}

// function for control default property //
function createNoneColorTip(listColorPickerEl) {
  listColorPickerEl.forEach(function (colorPickerEl) {
    if (colorPickerEl.getAttribute("data-tip") == "None") {
      colorPickerEl.querySelector("span").style["background-color"] = "";
    }
  });
}

function selectDefaultColorTips(productOptionEl, color) {
  productOptionEl.querySelectorAll(".product-options-colorpicker").forEach(function (colorTipEl) {
    if (colorTipEl.getAttribute("data-tip") == color) {
      colorTipEl.dispatchEvent(new Event("mousedown"));
    }
  });
  setPropertyDefaultAsNone(productOptionEl);
}

function setPropertyDefaultAsNone(productOptionEl) {
  productOptionEl.querySelectorAll("input[type='hidden']").forEach(function (dom) {
    if (!dom.value) {
      dom.value = "None";
    }
    console.log(dom.name, dom.value);
  });
}
////

// function for spinner //
function loadSpinner() {
  var wrapper = document.createElement("div");
  wrapper.className = "w3-product-options-spinner-wrapper";
  wrapper.prepend(document.createElement("div"));
  document.querySelector("main").prepend(wrapper);
}

function removeSpinner() {
  var spinnerWrapper = document.querySelector(".w3-product-options-spinner-wrapper");
  if (spinnerWrapper) {
    spinnerWrapper.remove();
  }
}

//// function for lifecycle //
function waitForAddedNode(params) {
  new MutationObserver(function (mutations) {
    var listEl = document.querySelectorAll(params.el);
    if (listEl.length) {
      this.disconnect();
      params.done(listEl);
    }
  }).observe(params.parent || document, {
    subtree: !!params.recursive || !params.parent,
    childList: true,
  });
}

function appAvailable(msg) {
  removeSpinner();
  console.log("[READY] now on custom options available | " + msg);
  window.clearTimeout(redirectTimeout);
  console.log("[DONE] remove redirect timeout");
}

// イメージ×テキストフィールドのテキストフィールドの変更時の処理
function onChangeNumber(el, productSlug) {
  // 数字のみを許可、4桁まで
  var numberCustomizerLayerEl = document.querySelector(`.number-customizer-layer`);
  var numberCustomizerImgEl = numberCustomizerLayerEl.querySelectorAll(`img`);
  if (!el.value) {
    numberCustomizerImgEl.forEach(function (numberCustomizerImgEl) {
      numberCustomizerImgEl.style.opacity = "0";
    });
    return;
  }
  let maxLength = 4;
  let regex = /[^0-9]/g;
  
  if (PRODUCT_DEFAULT_CONFIG[productSlug] && PRODUCT_DEFAULT_CONFIG[productSlug].textField) {
    const config = PRODUCT_DEFAULT_CONFIG[productSlug].textField;
    
    if (config.maxLength) {
      maxLength = config.maxLength;
    }
    
    if (config.inputType === "alphabetic") {
      regex = /[^a-zA-Z]/g;
    } else if (config.inputType === "alphanumeric") {
      regex = /[^a-zA-Z0-9]/g;
    }
  }
  
  if (!el.isComposing) {
    el.value = el.value.toUpperCase().replace(regex, "").slice(0, maxLength);
  }
  // 送信用の値を設定
  var fieldImageEl = document.querySelector(".product-options-textfield-value");
  var isSelectedImagePickerEl = document.querySelector(".product-options-imagepicker.imagepicker-selected");
  fieldImageEl.value = `${isSelectedImagePickerEl.getAttribute("data-name")}_${el.value}`;

  // 画像の変更
  var splitNumber = el.value.split("");
  var selectedImagePickerEl = document.querySelector(`.imagepicker-selected`);
  var groupName = numberCustomizerLayerEl.getAttribute("data-customizer-group-name");
  var positionName = numberCustomizerLayerEl.getAttribute("data-customizer-position-name");
  if (!selectedImagePickerEl) {
    return;
  }
  var logo = selectedImagePickerEl.getAttribute("data-value").toLowerCase();

  splitNumber.forEach(function (number, index) {
    numberCustomizerImgEl[index].style.webkitMaskImage = `url('https://storage.googleapis.com/you-and-sea-image/${productSlug}/option/${groupName}/${positionName}/${number}_${logo}.svg')`;
    numberCustomizerImgEl[index].style.maskImage = `url('https://storage.googleapis.com/you-and-sea-image/${productSlug}/option/${groupName}/${positionName}/${number}_${logo}.svg')`;
  });

  if (splitNumber.length == 0) {
    numberCustomizerImgEl.forEach(function (numberCustomizerImgEl) {
      numberCustomizerImgEl.style.opacity = "0";
    });
  } else if (splitNumber.length == 1) {
    numberCustomizerImgEl.forEach(function (numberCustomizerImgEl, index) {
      if (index == 0) {
        numberCustomizerImgEl.style.left = "0px";
        numberCustomizerImgEl.style.opacity = "1";
      } else {
        numberCustomizerImgEl.style.opacity = "0";
      }
    });
  } else if (splitNumber.length == 2) {
    numberCustomizerImgEl.forEach(function (numberCustomizerImgEl, index) {
      if (index == 0) {
        numberCustomizerImgEl.style.left = "-" + numberPotionOffset2 + "%";
        numberCustomizerImgEl.style.opacity = "1";
      } else if (index == 1) {
        numberCustomizerImgEl.style.left = numberPotionOffset2 + "%";
        numberCustomizerImgEl.style.opacity = "1";
      } else {
        numberCustomizerImgEl.style.opacity = "0";
      }
    });
  } else if (splitNumber.length == 3) {
    numberCustomizerImgEl.forEach(function (numberCustomizerImgEl, index) {
      if (index == 0) {
        numberCustomizerImgEl.style.left = "-" + numberPotionOffset3 + "%";
        numberCustomizerImgEl.style.opacity = "1";
      } else if (index == 1) {
        numberCustomizerImgEl.style.left = "0px";
        numberCustomizerImgEl.style.opacity = "1";
      } else if (index == 2) {
        numberCustomizerImgEl.style.left = numberPotionOffset3 + "%";
        numberCustomizerImgEl.style.opacity = "1";
      } else {
        numberCustomizerImgEl.style.opacity = "0";
      }
    });
  } else if (splitNumber.length == 4) {
    numberCustomizerImgEl.forEach(function (numberCustomizerImgEl, index) {
      if (index == 0) {
        numberCustomizerImgEl.style.left = "-" + numberPotionOffset4_4 + "%";
        numberCustomizerImgEl.style.opacity = "1";
      } else if (index == 1) {
        numberCustomizerImgEl.style.left = "-" + numberPotionOffset4_2 + "%";
        numberCustomizerImgEl.style.opacity = "1";
      } else if (index == 2) {
        numberCustomizerImgEl.style.left = numberPotionOffset4_2 + "%";
        numberCustomizerImgEl.style.opacity = "1";
      } else if (index == 3) {
        numberCustomizerImgEl.style.left = numberPotionOffset4_4 + "%";
        numberCustomizerImgEl.style.opacity = "1";
      }
    });
  } 
  if (fieldImageEl && fieldImageEl.value) {
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (form) {
      const inputName = fieldImageEl.name;
      const inputValue = fieldImageEl.value;
  
      // 既存の hidden input があれば削除
      const existingInput = form.querySelector(`input[name="${inputName}"]`);
      if (existingInput) {
        existingInput.remove();
      }
  
      // 新たに hidden input を追加
      const hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.name = inputName;
      hiddenInput.value = inputValue;
      form.appendChild(hiddenInput);
    }
  }
}

// カラー×テキストフィールドのカラー選択時の処理
function onClickColorPickerAndTextField(el) {
  el.parentElement.querySelectorAll(".product-options-colorpicker").forEach(function (option) {
    if (option == el) {
      option.classList.add("colorpicker-selected");
    } else {
      option.classList.remove("colorpicker-selected");
    }
  });
  
  // 送信用の値を設定
  var fieldInputEl = el.parentElement.parentElement.querySelector(".product-options-colorpicker-textfield-value");
  var isTextFieldValueEl = el.parentElement.parentElement.querySelector(".product-options-textfield");
  
  let maxLength = 4;
  let alertLength = 4;
  let validationEnabled = true; // Default to true
  
  if (
    typeof productSlug !== "undefined" &&
    PRODUCT_DEFAULT_CONFIG[productSlug] &&
    PRODUCT_DEFAULT_CONFIG[productSlug].textField
  ) {
    if (PRODUCT_DEFAULT_CONFIG[productSlug].textField.maxLength) {
      maxLength = PRODUCT_DEFAULT_CONFIG[productSlug].textField.maxLength;
    }
    if (PRODUCT_DEFAULT_CONFIG[productSlug].textField.alartLength) {
      alertLength = PRODUCT_DEFAULT_CONFIG[productSlug].textField.alartLength;
    }
    // Check if validation is enabled
    if (PRODUCT_DEFAULT_CONFIG[productSlug].textField.validationEnabled !== undefined) {
      validationEnabled = PRODUCT_DEFAULT_CONFIG[productSlug].textField.validationEnabled;
    }
  }

  if (isTextFieldValueEl.value && isTextFieldValueEl.value.length >= alertLength) {
    const suffix = PRODUCT_DEFAULT_CONFIG[productSlug]?.textField?.propertiesSuffix || '';
    fieldInputEl.value = `${suffix}${isTextFieldValueEl.value}_${el.getAttribute("data-name")}`;
  } else {
    fieldInputEl.value = `None`;
  }

  // レイヤーの表示・非表示
  var numberCustomizerLayerEl = document.querySelector(`.number-customizer-layer`);
  var numberCustomizerImgEl = numberCustomizerLayerEl.querySelectorAll(`img`);
  var alertEl = document.querySelector(".product-options-textfield-alert");
  
  if (el.getAttribute("data-name") && isTextFieldValueEl.value && isTextFieldValueEl.value.length >= alertLength) {
    numberCustomizerLayerEl.classList.remove("customizer-layer-hidden");
    numberCustomizerLayerEl.classList.add("customizer-layer-showing");
    var splitNumber = isTextFieldValueEl.value.split("");
    var groupName = numberCustomizerLayerEl.getAttribute("data-customizer-group-name");
    var positionName = numberCustomizerLayerEl.getAttribute("data-customizer-position-name");
    var color = el.getAttribute("data-name").toUpperCase();
    
    numberCustomizerImgEl.forEach(function(img) {
      img.style.opacity = "0";
    });
    
    splitNumber.forEach(function (number, index) {
      if (productSlug === "ref-youandsea10th-tote") {
        const currentLength = splitNumber.length;
        const lengthFolder = currentLength % 2 === 0 ? 6 : 5;
        
        // 桁数ごと
        let digitToUse;
        
        if (currentLength === 1) {
          // 1文字
          digitToUse = 3;
        } else if (currentLength === 2) {
          // 2文字
          digitToUse = index === 0 ? 3 : 4;
        } else if (currentLength === 3) {
          // 3文字
          digitToUse = index + 2;
        } else if (currentLength === 4) {
          // 4文字
          digitToUse = index + 2;
        } else {
          // 5,6文字
          digitToUse = index + 1;
        }
        
        numberCustomizerImgEl[index].src = `https://storage.googleapis.com/you-and-sea-image/${productSlug}/option/${groupName}/${positionName}/${lengthFolder}/${digitToUse}-digit/${color}/${number}.png`;
        numberCustomizerImgEl[index].src = imgSrc;
      } else {
        numberCustomizerImgEl[index].src = `https://storage.googleapis.com/you-and-sea-image/${productSlug}/option/${groupName}/${positionName}/${index+1}-digit/${color}/${number}.png`;
      }
      numberCustomizerImgEl[index].style.opacity = "1";
    });
    
    alertEl.style.display = "none";
  } else {
    numberCustomizerLayerEl.classList.add("customizer-layer-hidden");
    numberCustomizerLayerEl.classList.remove("customizer-layer-showing");
    numberCustomizerLayerEl.querySelectorAll(`img`).forEach(function (numberCustomizerImgEl) {
      numberCustomizerImgEl.style.opacity = "0";
    });
    
    // Only show alert if validation is enabled
    alertEl.style.display = validationEnabled ? "block" : "none";
  }

  if (el.getAttribute("data-name") && isTextFieldValueEl.value && isTextFieldValueEl.value.length >= alertLength) {
    alertEl.style.display = "none";
    isTextFieldValueEl.classList.remove("input-textfield-error");
  } else {
    // Only show error and add error class if validation is enabled
    alertEl.style.display = validationEnabled ? "block" : "none";
    if (validationEnabled) {
      isTextFieldValueEl.classList.add("input-textfield-error");
    } else {
      isTextFieldValueEl.classList.remove("input-textfield-error");
    }
  }

  if (fieldInputEl && fieldInputEl.name && fieldInputEl.value) {
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    const existingInput = form?.querySelector(`input[name="${fieldInputEl.name}"]`);

    if (fieldInputEl.value.length >= alertLength || !validationEnabled) {
      if (existingInput) {
        existingInput.value = fieldInputEl.value;
      } else {
        const hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = fieldInputEl.name;
        hiddenInput.value = fieldInputEl.value;
        form?.appendChild(hiddenInput);
      }
    } else {
      if (existingInput) {
        existingInput.remove();
      }
    }
  }
  saveTextFieldSelection();

  if (PRODUCT_DEFAULT_CONFIG[productSlug]?.componentToggle?.enabled) {
    toggleComponentsByTextLength(isTextFieldValueEl);
  }
}

// カラー×テキストフィールドのテキストフィールド変更時の処理
function onChangeColorPickerAndTextField(el) {
  var numberCustomizerLayerEl = document.querySelector(`.number-customizer-layer`);
  var numberCustomizerImgEl = numberCustomizerLayerEl.querySelectorAll(`img`);
  
  if (el.isComposing) {
    return;
  }

  let maxLength = 4;
  let alertLength = 4;
  let regex = /[^0-9]/g;
  let validationEnabled = true; 
  
  if (PRODUCT_DEFAULT_CONFIG[productSlug] && PRODUCT_DEFAULT_CONFIG[productSlug].textField) {
    const config = PRODUCT_DEFAULT_CONFIG[productSlug].textField;
    
    if (config.maxLength) {
      maxLength = config.maxLength;
    }

    if (config.alartLength) {
      alertLength = config.alartLength;
    }
    
    if (config.inputType === "alphabetic") {
      regex = /[^a-zA-Z]/g;
    } else if (config.inputType === "alphanumeric") {
      regex = /[^a-zA-Z0-9]/g;
    }
    
    if (config.validationEnabled !== undefined) {
      validationEnabled = config.validationEnabled;
    }
  }
  if (!el.isComposing) {
    el.value = el.value.toUpperCase().replace(regex, "").slice(0, maxLength);
  }
  // 送信用の値を設定
  var fieldInputEl = el.parentElement.parentElement.querySelector(".product-options-colorpicker-textfield-value");
  var isSelectedColorPickerEl = el.parentElement.querySelector(".product-options-picker-container .product-options-colorpicker.colorpicker-selected");
  
  const isValidLength = el.value && el.value.length >= alertLength;
  
  if (isSelectedColorPickerEl && isSelectedColorPickerEl.getAttribute("data-name") && el.value) {
    const suffix = PRODUCT_DEFAULT_CONFIG[productSlug]?.textField?.propertiesSuffix || '';
    fieldInputEl.value = `${suffix}${el.value}_${isSelectedColorPickerEl.getAttribute("data-name")}`;
  } else {
    fieldInputEl.value = `None`;
  }

  // レイヤーの表示・非表示
  var alertEl = document.querySelector(".product-options-textfield-alert");
  
  if (isSelectedColorPickerEl && isSelectedColorPickerEl.getAttribute("data-name") && el.value && el.value.length >= alertLength) {
    numberCustomizerLayerEl.classList.remove("customizer-layer-hidden");
    numberCustomizerLayerEl.classList.add("customizer-layer-showing");
    var splitNumber = el.value.split("");
    var groupName = numberCustomizerLayerEl.getAttribute("data-customizer-group-name");
    var positionName = numberCustomizerLayerEl.getAttribute("data-customizer-position-name");
    var color = isSelectedColorPickerEl.getAttribute("data-name").toUpperCase();
    
    numberCustomizerImgEl.forEach(function(img) {
      img.style.opacity = "0";
    });
    
    splitNumber.forEach(function (number, index) {
      if (productSlug === "ref-youandsea10th-tote") {
        const currentLength = splitNumber.length;
        const lengthFolder = currentLength % 2 === 0 ? 6 : 5;
        
        // 桁数ごと
        let digitToUse;
        
        if (currentLength === 1) {
          // 1文字
          digitToUse = 3;
        } else if (currentLength === 2) {
          // 2文字
          digitToUse = index === 0 ? 3 : 4;
        } else if (currentLength === 3) {
          // 3文字
          digitToUse = index + 2;
        } else if (currentLength === 4) {
          // 4文字
          digitToUse = index + 2;
        } else {
          // 5,6文字
          digitToUse = index + 1;
        }
        
        numberCustomizerImgEl[index].src = `https://storage.googleapis.com/you-and-sea-image/${productSlug}/option/${groupName}/${positionName}/${lengthFolder}/${digitToUse}-digit/${color}/${number}.png`;
      } else {
        numberCustomizerImgEl[index].src = `https://storage.googleapis.com/you-and-sea-image/${productSlug}/option/${groupName}/${positionName}/${index+1}-digit/${color}/${number}.png`;
      }
      numberCustomizerImgEl[index].style.opacity = "1";
    });
    
    alertEl.style.display = "none";
  } else {
    numberCustomizerLayerEl.classList.add("customizer-layer-hidden");
    numberCustomizerLayerEl.classList.remove("customizer-layer-showing");
    numberCustomizerLayerEl.querySelectorAll(`img`).forEach(function (numberCustomizerImgEl) {
      numberCustomizerImgEl.style.opacity = "0";
    });
    
    alertEl.style.display = validationEnabled ? "block" : "none";
  }

  if (isSelectedColorPickerEl && isSelectedColorPickerEl.getAttribute("data-name") && el.value && el.value.length >= alertLength) {
    alertEl.style.display = "none";
    el.classList.remove("input-textfield-error");
  } else {
    alertEl.style.display = validationEnabled ? "block" : "none";
    if (validationEnabled) {
      el.classList.add("input-textfield-error");
    } else {
      el.classList.remove("input-textfield-error");
    }
  }
  
  // フォームへの反映
  if (fieldInputEl && fieldInputEl.name && fieldInputEl.value) {
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    const existingInput = form?.querySelector(`input[name="${fieldInputEl.name}"]`);

    if (fieldInputEl.value.length >= alertLength || !validationEnabled) {
      if (existingInput) {
        existingInput.value = fieldInputEl.value;
      } else {
        const hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = fieldInputEl.name;
        hiddenInput.value = fieldInputEl.value;
        form?.appendChild(hiddenInput);
      }
    } else {
      if (existingInput) {
        existingInput.remove();
      }
    }
  }
  saveTextFieldSelection();
  
  if (PRODUCT_DEFAULT_CONFIG[productSlug]?.componentToggle?.enabled) {
    toggleComponentsByTextLength(el);
  }
}

function toggleComponentsByTextLength(el) {
  if (!PRODUCT_DEFAULT_CONFIG[productSlug]?.componentToggle?.enabled) {
    return;
  }
  
  const config = PRODUCT_DEFAULT_CONFIG[productSlug].componentToggle;
  const textLength = el.value.length;
  const threshold = config.textFieldThreshold || 5;
  
  const logoLayers = document.querySelectorAll('[data-customizer-image-color-name]');
  const form = document.querySelector('form[data-type="add-to-cart-form"]');
  
  if (textLength >= threshold) {
    logoLayers.forEach(layer => {
      layer.classList.add('customizer-layer-hidden');
      layer.classList.remove('customizer-layer-showing');
    });
    
    if (form) {
      const imgColorInputs = document.querySelectorAll('.product-options-control-container[data-name] input[type="hidden"]');
      imgColorInputs.forEach(input => {
        const container = input.closest('.product-options-control-container');
        if (!container.querySelector('.product-options-colorpicker-textfield-value')) {
          const name = input.name;
          const formInput = form.querySelector(`input[name="${name}"]`);
          if (formInput) {
            formInput.remove();
          }
        }
      });
      
      const textFieldContainer = el.closest('.product-options-control-container');
      if (textFieldContainer) {
        const positionName = textFieldContainer.getAttribute('data-name');
        const selectedColorPicker = textFieldContainer.querySelector('.product-options-colorpicker.colorpicker-selected');
        const textValue = el.value;
        
        if (positionName && selectedColorPicker && textValue) {
          const colorName = selectedColorPicker.getAttribute('data-name');
          const propName = `properties[${positionName}]`;
          let propInput = form.querySelector(`input[name="${propName}"]`);
          
          if (!propInput) {
            propInput = document.createElement('input');
            propInput.type = 'hidden';
            propInput.name = propName;
            form.appendChild(propInput);
          }
          
          const suffix = PRODUCT_DEFAULT_CONFIG[productSlug]?.textField?.propertiesSuffix || "";
          propInput.value = `${suffix}${textValue}_${colorName}`;
        }
      }
    }
  } else {
    const selectedImagePicker = document.querySelector('.product-options-imagepicker.imagepicker-selected');
    const selectedColorPicker = document.querySelector('.product-options-colorpicker.colorpicker-selected');
    
    if (selectedImagePicker && selectedColorPicker) {
      const imageName = selectedImagePicker.getAttribute('data-name');
      const colorName = selectedColorPicker.getAttribute('data-name');
      const fullName = `${imageName}_${colorName}`;
      const positionName = selectedImagePicker.getAttribute('data-option-position-name');
      
      logoLayers.forEach(layer => {
        if (layer.getAttribute('data-customizer-image-color-name') === fullName) {
          layer.classList.remove('customizer-layer-hidden');
          layer.classList.add('customizer-layer-showing');
        } else {
          layer.classList.add('customizer-layer-hidden');
          layer.classList.remove('customizer-layer-showing');
        }
      });
      
      if (form && positionName) {
        const propName = `properties[${positionName}]`;
        let propInput = form.querySelector(`input[name="${propName}"]`);
        
        if (!propInput) {
          propInput = document.createElement('input');
          propInput.type = 'hidden';
          propInput.name = propName;
          form.appendChild(propInput);
        }
        
        propInput.value = fullName;
      }
    }
  }
}

function selectFirstColorRadio() {
  const colorFieldset = document.querySelector("fieldset[data-product-tags*='custom-product-slug=']");
  if (!colorFieldset) return;

  const radios = colorFieldset.querySelectorAll("input[type='radio']");
  if (!radios.length) return;

  const tags = colorFieldset.dataset.productTags.replace(/\s+/g, "").split(",");
  let slug;
  for (const tag of tags) {
    const match = tag.match(/^custom-product-slug=([A-Za-z0-9-_]+)/);
    if (match) {
      slug = match[1];
      break;
    }
  }

  const urlParams = new URLSearchParams(window.location.search);
  const variantParam = urlParams.get('variant');

  if (variantParam) {
    console.log(`URL contains variant parameter: ${variantParam}, skipping baseColor default selection`);
    return;
  }

  // セッションストレージから選択データを取得
  const sessionSelections = JSON.parse(sessionStorage.getItem("YANDS_SELECTED") || "{}");
  const sessionData = sessionSelections[slug] || {};
  const hasPreviousSelection = sessionData.baseColor && sessionData.baseColor.selectedColor;

  if (PRODUCT_DEFAULT_CONFIG[slug] && !hasPreviousSelection) {
    const defaultBaseColor = PRODUCT_DEFAULT_CONFIG[slug].baseColor || "NATURAL";
    
    const defaultRadio = Array.from(radios).find(radio => 
      radio.value.trim().toUpperCase() === defaultBaseColor);
    
    if (defaultRadio) {
      defaultRadio.checked = true;
      
      const selectedValueEl = colorFieldset.querySelector("legend span[data-selected-value]");
      if (selectedValueEl) {
        selectedValueEl.textContent = defaultRadio.value;
      }
      
      bodyVariant = defaultBaseColor;
      
      updateDefaultOptions(bodyVariant);
      saveBaseColorSelection();
      
      console.log(`${defaultBaseColor} color was force-selected for ${slug} (first visit)`);
      return;
    }
  }

  const savedBaseColor = sessionData.baseColor?.selectedColor;
  
  let selectedRadio = null;
  
  if (savedBaseColor) {
    selectedRadio = Array.from(radios).find(radio => 
      radio.value.trim().toUpperCase() === savedBaseColor);
  }

  if (!selectedRadio) return;
  
  selectedRadio.checked = true;
  selectedRadio.dispatchEvent(new Event('change', { bubbles: true }));

  const selectedValueEl = colorFieldset.querySelector("legend span[data-selected-value]");
  if (selectedValueEl) {
    selectedValueEl.textContent = selectedRadio.value;
  }

  const newVariant = selectedRadio.value.trim().toUpperCase();
  bodyVariant = newVariant;
  updateDefaultOptions(bodyVariant);
  saveBaseColorSelection();
  
  setTimeout(() => {
    restoreCustomizationState();
  }, 100);
}

function restoreCustomizationState() {
  const sessionSelections = JSON.parse(sessionStorage.getItem("YANDS_SELECTED") || "{}");
  const sessionData = sessionSelections[productSlug] || {};
  
  if (sessionData.colorImage) {
    const defaultImage = sessionData.colorImage.selectedImage;
    const defaultColor = sessionData.colorImage.selectedColor;
    
    if (defaultImage && defaultColor) {
      const imagePicker = document.querySelector(`.product-options-imagepicker[data-name="${defaultImage}"]`);
      if (imagePicker) {
        imagePicker.click();
      }
      
      const colorPicker = document.querySelector(`.product-options-colorpicker[data-name="${defaultColor}"]`);
      if (colorPicker) {
        colorPicker.click();
      }
      const toDataName = `${defaultImage}_${defaultColor}`;
      const positionName = imagePicker?.getAttribute("data-option-position-name");
      if (positionName) {
        const elems = document.querySelectorAll(`[data-customizer-position-name="${positionName}"]`);
        elems.forEach(elem => {
          if (elem.getAttribute("data-customizer-image-color-name") === toDataName) {
            elem.classList.remove("customizer-layer-hidden");
            elem.classList.add("customizer-layer-showing");
          } else {
            elem.classList.add("customizer-layer-hidden");
            elem.classList.remove("customizer-layer-showing");
          }
        });
      }
    }
  }
  
  if (sessionData.textField) {
    const textFieldValue = sessionData.textField.selectedText;
    const textFieldColor = sessionData.textField.selectedColor;
    
    if (textFieldValue || textFieldColor) {
      const textField = document.querySelector(".product-options-textfield");
      if (textField && textFieldValue) {
        textField.value = textFieldValue;
      }
      
      const colorPicker = document.querySelector(`.product-options-colorpicker[data-name="${textFieldColor}"]`);
      if (colorPicker) {
        colorPicker.click();
      }
      
      if (textField) {
        textField.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }
  }
  if (sessionData.customMode) {
    customMode = sessionData.customMode;
    const radioInput = document.querySelector(`input[name="customMode"][value="${customMode}"]`);
    if (radioInput) {
      radioInput.checked = true;
      applyCustomMode();
    }
  }
}

function updateDefaultOptions(selectedColor) {
  const match = customBaseColors.find(base => base.bodyColor === selectedColor);
  if (match) {
    const baseImage = document.querySelector('.option-customizer-base-layer');
    if (baseImage) {
      baseImage.setAttribute('src', match.imageUrl);
    }
    
    // ボディカラーに応じて刺繍カラーを自動選択
    if (PRODUCT_DEFAULT_CONFIG[productSlug]?.bodyEmbroideryColors) {
      const embroideryColor = PRODUCT_DEFAULT_CONFIG[productSlug].bodyEmbroideryColors[selectedColor];
      
      if (embroideryColor) {
        // 全てのカラーピッカーを更新
        const allColorPickers = document.querySelectorAll('.product-options-colorpicker');
        const matchingPickers = [];
        
        // まず一致するカラーピッカーを全て見つける
        allColorPickers.forEach(picker => {
          if (picker.getAttribute("data-name").toUpperCase() === embroideryColor) {
            matchingPickers.push(picker);
          }
        });
        
        // 見つかったピッカーごとに処理
        matchingPickers.forEach(picker => {
          // 同じコンテナ内の全てのカラーピッカーから選択を解除
          const container = picker.closest('.product-options-control-container');
          if (container) {
            container.querySelectorAll('.product-options-colorpicker').forEach(p => {
              p.classList.remove('colorpicker-selected');
            });
            
            // 対象のピッカーを選択状態に
            picker.classList.add('colorpicker-selected');
            
            // コンテナのタイプに応じて処理
            if (container.querySelector('.product-options-colorpicker-textfield-value')) {
              // テキストフィールド＆カラーピッカーの場合
              const textField = container.querySelector('.product-options-textfield');
              if (textField && textField.value) {
                const fieldInputEl = container.querySelector('.product-options-colorpicker-textfield-value');
                if (fieldInputEl) {
                  fieldInputEl.value = `${textField.value}_${embroideryColor}`;
                  updateFormHiddenInputFromInput(fieldInputEl);
                  
                  // テキストフィールドのイベントを発火して表示を更新
                  textField.dispatchEvent(new Event('input', { bubbles: true }));
                }
              }
            } else if (container.querySelector('.product-options-imagepicker')) {
              // 画像＆カラーピッカーの場合
              const selectedImagePicker = container.querySelector('.product-options-imagepicker.imagepicker-selected');
              if (selectedImagePicker) {
                const fieldInputEl = container.querySelector('input[type="hidden"]');
                if (fieldInputEl) {
                  const imageName = selectedImagePicker.getAttribute('data-name');
                  fieldInputEl.value = `${imageName}_${embroideryColor}`;
                  updateFormHiddenInputFromInput(fieldInputEl);
                  
                  // イメージレイヤーの表示も更新
                  const positionName = selectedImagePicker.getAttribute('data-option-position-name');
                  const toDataName = `${imageName}_${embroideryColor}`;
                  const elems = document.querySelectorAll(`[data-customizer-position-name="${positionName}"]`);
                  elems.forEach(elem => {
                    if (elem.getAttribute('data-customizer-image-color-name') === toDataName) {
                      elem.classList.remove('customizer-layer-hidden');
                      elem.classList.add('customizer-layer-showing');
                    } else {
                      elem.classList.add('customizer-layer-hidden');
                      elem.classList.remove('customizer-layer-showing');
                    }
                  });
                }
              }
            }
          }
        });
        
        // セッションストレージも更新
        saveTextFieldSelection();
        saveColorImageSelection();
      }
    }
  } else {
    console.log(`[一致なし] ${selectedColor} に対応する画像は見つかりません`);
  }
}

function selectFirstOptions() {
  const sessionSelections = JSON.parse(sessionStorage.getItem("YANDS_SELECTED") || "{}");
  const sessionData = sessionSelections[productSlug] || {};
  const allControlContainers = document.querySelectorAll(".you-and-sea-options .product-options-control-container");

  allControlContainers.forEach(container => {
    const containerType = determineContainerType(container);
    const positionName = container.getAttribute("data-name");
    
    // コンテナのタイプに応じた処理
    switch (containerType) {
      case "ColorPickerAndImagePicker":
        handleColorPickerAndImagePicker(container);
        break;
      case "ColorPickerAndTextField":
        handleColorPickerAndTextField(container);
        break;
      default:
        handleDefaultContainer(container);
        break;
    }
  });
  
  function determineContainerType(container) {
    if (container.querySelector(".product-options-colorpicker-textfield-value")) {
      return "ColorPickerAndTextField";
    } else if (container.querySelector(".product-options-imagepicker") && 
              container.querySelector(".product-options-colorpicker")) {
      return "ColorPickerAndImagePicker";
    }
    return "other";
  }
  
  function handleColorPickerAndImagePicker(container) {
    const sessionColorImage = sessionData.colorImage || {};
    const defaultImage = sessionColorImage.selectedImage || PRODUCT_DEFAULT_CONFIG[productSlug]?.colorImage?.defaultImage;
    const defaultColor = sessionColorImage.selectedColor || PRODUCT_DEFAULT_CONFIG[productSlug]?.colorImage?.defaultColor;
  
    const imagePickers = container.querySelectorAll(".product-options-imagepicker");
    let selectedImagePicker = null;
    imagePickers.forEach(picker => {
      if (picker.getAttribute("data-name") === defaultImage) {
        picker.classList.add("imagepicker-selected");
        selectedImagePicker = picker;
      } else {
        picker.classList.remove("imagepicker-selected");
      }
    });
    if (selectedImagePicker) {
      selectedImagePicker.click();
    } else if (imagePickers[0]) {
      imagePickers[0].click();
    }
  
    const colorPickers = container.querySelectorAll(".product-options-colorpicker");
    let selectedColorPicker = null;
    colorPickers.forEach(picker => {
      if (picker.getAttribute("data-name") === defaultColor) {
        picker.classList.add("colorpicker-selected");
        selectedColorPicker = picker;
      } else {
        picker.classList.remove("colorpicker-selected");
      }
    });
    if (selectedColorPicker) {
      selectedColorPicker.click();
    } else if (colorPickers[0]) {
      colorPickers[0].click();
    }
  
    if (selectedImagePicker && selectedColorPicker) {
      const toDataName = `${selectedImagePicker.getAttribute("data-name")}_${selectedColorPicker.getAttribute("data-name")}`;
      const hiddenInput = container.querySelector("input[type='hidden']");
      if (hiddenInput) {
        hiddenInput.value = toDataName;
        updateFormHiddenInputFromInput(hiddenInput);
      }
  
      const positionName = selectedImagePicker.getAttribute("data-option-position-name");
      const elems = document.querySelectorAll(`[data-customizer-position-name="${positionName}"]`);
      elems.forEach(el => {
        if (el.getAttribute("data-customizer-image-color-name") === toDataName) {
          el.classList.remove("customizer-layer-hidden");
          el.classList.add("customizer-layer-showing");
        } else {
          el.classList.add("customizer-layer-hidden");
          el.classList.remove("customizer-layer-showing");
        }
      });
    }
  }
  
  function handleColorPickerAndTextField(container) {
    const sessionTextField = sessionData.textField || {};
    const config = PRODUCT_DEFAULT_CONFIG[productSlug]?.textField || {};
    const toggleConfig = PRODUCT_DEFAULT_CONFIG[productSlug]?.componentToggle;
    
    let defaultColor = null;
  
  if (productSlug === "ref-youandsea10th-tote" && 
      PRODUCT_DEFAULT_CONFIG[productSlug]?.bodyEmbroideryColors && 
      bodyVariant) {
    defaultColor = PRODUCT_DEFAULT_CONFIG[productSlug].bodyEmbroideryColors[bodyVariant];
  }
  
  // 設定されていなければセッション保存値やデフォルト値をフォールバックとして使用
  if (!defaultColor) {
    defaultColor = sessionTextField.selectedColor || config.defaultColor;
  }
  
  let defaultText = sessionTextField.selectedText || config.defaultText;
  
    if (toggleConfig?.enabled && sessionTextField.selectedText === "") {
      defaultText = "";
    }
  
    const textField = container.querySelector(".product-options-textfield");
    // if (textField && defaultText !== undefined) {
    //   textField.value = defaultText;
    // }
    if (textField && defaultText !== undefined) {
      setTimeout(() => {
        textField.value = defaultText;
    
        textField.dispatchEvent(new Event("input", { bubbles: true }));
    
        // Safari対策
        textField.focus();
        textField.blur();
      }, 50);
    }
    
    const colorPickers = container.querySelectorAll(".product-options-colorpicker");
    let selectedColorPicker = null;
    colorPickers.forEach(picker => {
      if (picker.getAttribute("data-name").toUpperCase() === defaultColor?.toUpperCase()) {
        picker.classList.add("colorpicker-selected");
        selectedColorPicker = picker;
      } else {
        picker.classList.remove("colorpicker-selected");
      }
    });
    if (selectedColorPicker) {
      selectedColorPicker.click();
    } else if (colorPickers[0]) {
      colorPickers[0].click();
    }
  
    if (textField) {
      textField.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }
  
  function handleDefaultContainer(container) {
    const firstImage = container.querySelector(".product-options-imagepicker.options-tip");
    if (firstImage && !firstImage.classList.contains("imagepicker-selected")) {
      firstImage.click();
    }
    
    const hasSelectedColor = container.querySelector(".product-options-colorpicker.colorpicker-selected");
    if (!hasSelectedColor) {
      const firstColor = container.querySelector(".product-options-colorpicker.options-tip");
      if (firstColor) {
        firstColor.click();
      }
    }
    
    const textField = container.querySelector(".product-options-textfield");
    const hiddenInput = container.querySelector(".product-options-colorpicker-textfield-value");
    
    if (textField && hiddenInput) {
      if (!textField.value) {
        const number = 1234;
        textField.value = String(number);
      }
      
      textField.dispatchEvent(new Event("input", { bubbles: true }));
      
      const selectedColor = container.querySelector(".options-tip.colorpicker-selected")?.getAttribute("data-name") || "";
      if (selectedColor && textField.value) {
        hiddenInput.value = `${textField.value}_${selectedColor}`;
        updateFormHiddenInputFromInput(hiddenInput);
      }
    }
  }
}

function saveToSessionStorage(slug, data) {
  const allSelections = JSON.parse(sessionStorage.getItem("YANDS_SELECTED") || "{}");
  allSelections[slug] = {
    ...(allSelections[slug] || {}),
    ...data
  };
  sessionStorage.setItem("YANDS_SELECTED", JSON.stringify(allSelections));
}

function saveBaseColorSelection() {
  if (!bodyVariant) return;

  saveToSessionStorage(productSlug, {
    baseColor: {
      selectedColor: bodyVariant
    }
  });
}

function saveColorImageSelection() {
  const image = document.querySelector(".product-options-imagepicker.imagepicker-selected")?.getAttribute("data-name");
  const color = document.querySelector(".product-options-colorpicker.colorpicker-selected")?.getAttribute("data-name");

  if (!image || !color) return;

  saveToSessionStorage(productSlug, {
    colorImage: {
      selectedImage: image,
      selectedColor: color
    }
  });
}

function saveColorPickerSelection() {
  const color = document.querySelector(".product-options-colorpicker.colorpicker-selected")?.getAttribute("data-name");

  if (!color) return;

  saveToSessionStorage(productSlug, {
    colorPicker: {
      selectedColor: color
    }
  });
}
function saveImagePickerSelection() {
  const image = document.querySelector(".product-options-imagepicker.imagepicker-selected")?.getAttribute("data-name");

  if (!image) return;

  saveToSessionStorage(productSlug, {
    imagePicker: {
      selectedImage: image
    }
  });
}

function saveTextFieldSelection() {
  const container = document.querySelector(".product-options-colorpicker-textfield-value")?.closest(".product-options-control-container");
  if (!container) return;

  const textField = container.querySelector(".product-options-textfield");
  const color = container.querySelector(".product-options-colorpicker.colorpicker-selected")?.getAttribute("data-name");
  const text = textField?.value;

  if (!text || !color) return;

  const config = PRODUCT_DEFAULT_CONFIG[productSlug]?.componentToggle;
  const threshold = config?.textFieldThreshold || 5;
  
  if (config?.enabled && text.length < threshold) {
    saveToSessionStorage(productSlug, {
      textField: {
        selectedText: "",
        selectedColor: ""
      }
    });
  } else {
    const trimmedText = text.trim();
    saveToSessionStorage(productSlug, {
      textField: {
        selectedText: trimmedText,
        selectedColor: color
      }
    });
  }
}

// function saveTextFieldSelection() {
//   const container = document
//     .querySelector(".product-options-colorpicker-textfield-value")
//     ?.closest(".product-options-control-container");
//   if (!container) return;

//   const textField = container.querySelector(".product-options-textfield");
//   // color が取得できなければ空文字にしておく
//   const color = container.querySelector(".product-options-colorpicker.colorpicker-selected")?.getAttribute("data-name") || "";
//   const text = textField ? textField.value : "";

//   // テキストが空の場合は、空文字で保存して終了
//   if (text.trim() === "") {
//     saveToSessionStorage(productSlug, {
//       textField: {
//         selectedText: "",
//         selectedColor: ""
//       }
//     });
//     return;
//   }

//   const config = PRODUCT_DEFAULT_CONFIG[productSlug]?.componentToggle;
//   const threshold = config?.textFieldThreshold || 5;
  
//   if (config?.enabled && text.length < threshold) {
//     saveToSessionStorage(productSlug, {
//       textField: {
//         selectedText: "",
//         selectedColor: ""
//       }
//     });
//   } else {
//     const trimmedText = text.trim();
//     saveToSessionStorage(productSlug, {
//       textField: {
//         selectedText: trimmedText,
//         selectedColor: color
//       }
//     });
//   }
// }

async function getImageUrlForColor(color) {
  try {
    var apiUrl = "";
    if (location.hostname == "windandsea.jp" || location.hostname == "www.windandsea.jp" || location.hostname == "windandsea-wear.myshopify.com") {
      apiUrl = "https://youandsea.windandsea.jp/products/options/";
    } else {
      apiUrl = "https://staging-youandsea.windandsea.jp/products/options/";
    }
    
    const res = await fetch(apiUrl + productSlug);
    const data = await res.json();
    
    customBaseColors = data.bases;
    
    let imageUrl = null;
    if (data.bases) {
      const matchingBase = data.bases.find(base => base.bodyColor === color);
      if (matchingBase && matchingBase.imageUrl) {
        imageUrl = matchingBase.imageUrl;
      }
    }
    
    return imageUrl;
  } catch (error) {
    console.error("Error fetching image URL:", error);
    return null;
  }
}

const imageUrlCache = {};

document.addEventListener('change', async function (e) {
  if (e.target.type !== 'radio') return;

  const fieldset = e.target.closest('fieldset[data-product-tags]');
  if (!fieldset || !fieldset.dataset.productTags.includes('custom-product-slug=')) return;

  const selected = fieldset.querySelector('input[type="radio"]:checked');
  if (!selected) return;
  
  const newVariant = selected.value.trim().toUpperCase();
  if (bodyVariant === newVariant) return; // 変更がなければ何もしない
  
  bodyVariant = newVariant;
  console.log(`カラーが変更されました: ${bodyVariant}`);
  
  const baseImage = document.querySelector('.option-customizer-base-layer');
  if (baseImage) {
    baseImage.style.opacity = "0.5";
  }
  
  let imageUrl;
  if (imageUrlCache[bodyVariant]) {
    imageUrl = imageUrlCache[bodyVariant];
    console.log(`キャッシュから画像URL取得: ${imageUrl}`);
  } else {
    console.log(`APIからカラー ${bodyVariant} の画像URL取得中...`);
    imageUrl = await getImageUrlForColor(bodyVariant);
    if (imageUrl) {
      imageUrlCache[bodyVariant] = imageUrl; // キャッシュに保存
      console.log(`新しい画像URLをキャッシュしました: ${imageUrl}`);
    }
  }
  
  if (imageUrl && baseImage) {
    baseImage.src = imageUrl;
    baseImage.onload = function() {
      baseImage.style.opacity = "1"; // 通常の表示に戻す
    };
  } else {
    console.warn(`${bodyVariant} に対応する画像URLが見つかりませんでした`);
    if (baseImage) {
      baseImage.style.opacity = "1";
    }
  }
  
  updateDefaultOptions(bodyVariant);
  saveBaseColorSelection();
});

async function preloadColorImages() {
  const radios = document.querySelectorAll('fieldset[data-product-tags*="custom-product-slug="] input[type="radio"]');
  if (!radios.length) return;
  
  for (const radio of radios) {
    const color = radio.value.trim().toUpperCase();
    if (!imageUrlCache[color]) {
      const imageUrl = await getImageUrlForColor(color);
      if (imageUrl) {
        imageUrlCache[color] = imageUrl;
        
      }
    }
  }
  
  console.log("画像のプリロードが完了しました");
}

document.addEventListener('DOMContentLoaded', function() {
  preloadColorImages();
});